import { useVeltClient, VeltVideoPlayer, VeltSidebarButton, VeltCommentTool, VeltHuddleTool, VeltPresence } from '@veltdev/react';
import { useEffect, useState } from 'react';

import YourAuthComponent from './YourAuthComponent';

export default function YourDocument() {

  // Get the Velt client
  const { client } = useVeltClient();

  useEffect(() => {
    if (client) {
      // Set a document ID
      client.setDocumentId('promo-demo-asdfsdafadsfid');
      const selectionElement = client.getSelectionElement();
      selectionElement.enableLiveSelection();

    }
  }, [client]);

  return (
    <>
    <noscript>
      &lt;img height="1" width="1" style="display:none;" alt=""
      src="https://ct.pinterest.com/v3/?event=init&amp;tid=2613017108570&amp;pd[em]=%3Chashed_email_address%3E&amp;noscript=1"
      /&gt;
    </noscript>
    <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta
      property="twitter:app:name:iphone"
      content="Promo: Marketing Video Maker"
    />
    <meta property="twitter:app:id:iphone" content={1304321154} />
    <meta
      property="twitter:app:name:ipad"
      content="Promo: Marketing Video Maker"
    />
    <meta property="twitter:app:id:ipad" content={1304321154} />
    <meta
      property="twitter:app:name:googleplay"
      content="Promo: Marketing Video Maker"
    />
    <meta property="twitter:app:id:googleplay" content="com.promo.mobile" />
    <meta
      property="twitter:app:url:googleplay"
      content="https://play.google.com/store/apps/details?id=com.promo.mobile"
    />
    <meta property="al:ios:url" content="app.promo://home" />
    <meta property="al:ios:app_store_id" content={1304321154} />
    <meta property="al:ios:app_name" content="Promo: Marketing Video Maker" />
    <meta property="al:android:url" content="app.promo://home" />
    <meta property="al:android:app_name" content="Promo: Marketing Video Maker" />
    <meta property="al:android:package" content="com.promo.mobile" />
    <meta property="og:updated_time" content={1709770217} />
    <meta
      property="og:url"
      content="https://promo.com/share/65e905b9f40e455e11747bc2"
    />
    <meta
      property="og:title"
      content="Check out my Video - Created with Promo.com"
    />
    <meta
      property="og:description"
      content="Promo.com gives you ready-made video templates, high-quality footage, fully-licensed music, a built-in editor and free image tools so you can create stunning marketing visuals to promote anything, anywhere."
    />
    <meta property="og:type" content="object" />
    <meta
      property="og:image"
      content="https://ak04-promo-cdn.slidely.com/promoVideos/thumbnail/share?url=https%3A%2F%2Fez-media.s3.amazonaws.com%2Fmedia%2Fvideos%2F27%2Fe2%2Fthumbs%2F27e21c91314f06f35bd18c718c53b541--thumb-0.jpg&for=facebook&dv=1"
    />
    <meta property="og:image:width" content={1200} />
    <meta property="og:image:height" content={630} />
    <meta property="og:site_name" content="Promo.com" />
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:site" content="@promodotcom" />
    <meta
      property="twitter:title"
      content="Check out my Video - Created with Promo.com"
    />
    <meta
      property="twitter:description"
      content="Promo.com gives you ready-made video templates, high-quality footage, fully-licensed music, a built-in editor and free image tools so you can create stunning marketing visuals to promote anything, anywhere."
    />
    <meta
      property="twitter:image:src"
      content="https://ak04-promo-cdn.slidely.com/promoVideos/thumbnail/share?url=https%3A%2F%2Fez-media.s3.amazonaws.com%2Fmedia%2Fvideos%2F27%2Fe2%2Fthumbs%2F27e21c91314f06f35bd18c718c53b541--thumb-0.jpg&for=twitter&dv=1"
    />
    <meta
      name="description"
      content="Every promotion starts with Promo.com. Grow your business with high-quality video ads, promotional videos and visual content that brings winning results."
    />
    <meta
      property="og:image:secure_url"
      content="https://ak04-promo-cdn.slidely.com/promoVideos/thumbnail/share?url=https%3A%2F%2Fez-media.s3.amazonaws.com%2Fmedia%2Fvideos%2F27%2Fe2%2Fthumbs%2F27e21c91314f06f35bd18c718c53b541--thumb-0.jpg&for=facebook&dv=1"
    />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
    />
    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
    <meta property="fb:app_id" content={255083304564274} />
    <meta name="pinterest" content="nohover" />
    <title>
      Promo.com | Marketing Video Maker | Promote Anything with Videos
    </title>
    <meta
      httpEquiv="origin-trial"
      content="A3dA86xx3SygInSznfsu98uiaY4VmGo/CaJTGvdsIU5xobyXgN1lb1smNdWPEoeyz54s3L60Kdxmc4VJmUrrIgoAAACVeyJvcmlnaW4iOiJodHRwczovL2N0LnBpbnRlcmVzdC5jb206NDQzIiwiZmVhdHVyZSI6IkRpc2FibGVUaGlyZFBhcnR5U3RvcmFnZVBhcnRpdGlvbmluZyIsImV4cGlyeSI6MTcyNTQwNzk5OSwiaXNTdWJkb21haW4iOnRydWUsImlzVGhpcmRQYXJ0eSI6dHJ1ZX0="
    />
    <div id="promo-top-banner" />
    <header
      className="dark-theme header show fixation-opaque opaque"
      data-is-fixed={1}
    >
      <aside className="logo">
        <a href="/" alt="promo logo" className="promo-logo " />
      </aside>
      <div data-qaid="header_left_side" className="links links--left ">
        <div className="links__item links__item--what-you-can-do links__item--dropdown">
          <span data-qaid="header_create">
            <a
              className="links__item--dropdown__btn"
              data-qaid="header_make"
              href="/create"
            >
              Create{" "}
            </a>
          </span>
          <div className="links__item--dropdown__area">
            <div className="container">
              <div className="container__item">
                <div className="title">Social Media</div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_calendar"
                      href="https://promo.com/tools/calendar/march"
                    >
                      Daily Calendar Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_facebook_ads"
                      href="/for/facebook/videos"
                    >
                      Facebook Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_instagram_ads"
                      href="/for/instagram/videos"
                    >
                      Instagram Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_youtube_ads"
                      href="/for/youtube/videos"
                    >
                      YouTube Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_linkedin_ads"
                      href="/for/youtube/intros"
                    >
                      YouTube Intro Videos
                    </a>
                  </li>
                </ul>
              </div>
              <div className="container__item">
                <div className="title">Industries</div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_real_estate_videos"
                      href="/for/real-estate-videos"
                    >
                      Real Estate Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_fitness_videos"
                      href="/for/fitness"
                    >
                      Fitness Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_fashion_videos"
                      href="/for/fashion"
                    >
                      Fashion Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_restaurant_videos"
                      href="/for/restaurants"
                    >
                      Restaurant Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_travel_videos"
                      href="/for/travel"
                    >
                      Travel Videos
                    </a>
                  </li>
                </ul>
              </div>
              <div className="container__item">
                <div className="title">Marketing</div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_commercial_maker"
                      href="/for/commercials"
                    >
                      Commercial Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_facebook_story_ads"
                      href="/for/facebook/story-ads"
                    >
                      Facebook Story Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_instagram_story_ads"
                      href="/for/instagram/story-ads"
                    >
                      Instagram Story Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_linkedIn_story_ads"
                      href="/for/linkedin/ads"
                    >
                      LinkedIn Video Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_instagram_story_ads"
                      href="/for/youtube/ads"
                    >
                      YouTube Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_promo_videos"
                      href="/for/promo-videos"
                    >
                      Promo Videos
                    </a>
                  </li>
                </ul>
              </div>
              <div className="container__item">
                <div className="title">E-commerce</div>
                <ul className="panel">
                  <li>
                    <a data-qaid="header_submenu_ecommerce" href="/for/ecommerce">
                      E-commerce Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_amazon_ads"
                      href="/for/amazon/ads"
                    >
                      Amazon Video Ads
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="links__item links__item--what-you-can-do links__item--dropdown">
          <span data-qaid="templates">
            <a
              className="links__item--dropdown__btn"
              data-qaid="header_make"
              href="/templates"
            >
              Templates{" "}
            </a>
          </span>
        
        </div>
        <div className="links__item links__item--resources links__item--dropdown">
          <span data-qaid="header_resources">
            <a
              className="links__item--dropdown__btn"
              data-qaid="header_make"
              href="/tools"
            >
              Tools{" "}
            </a>
          </span>
          
        </div>
        <div className="links__item links__item--resources links__item--dropdown">
          <span data-qaid="header_resources">
            <a
              className="links__item--dropdown__btn"
              data-qaid="header_make"
              href="/learn"
            >
              Resources{" "}
            </a>
          </span>
       
        </div>
        <div className="links__item">
          <a
            data-qaid="header_link_promoai"
            className="promoai"
            data-link-location="header"
            href="/promo-ai-social-media-manager?utm_content=site_header"
          >
            PromoAI{" "}
          </a>
        </div>
        <div className="links__item">
          <a data-qaid="header_link_pricing" href="/pricing" className="pricing">
            Pricing
          </a>
        </div>
      </div>
      <div style={{justifyContent:'flex-end', display:"flex", gap:"16px", marginRight:"16px", alignItems:"center"}}>
          <VeltPresence/>
          <VeltHuddleTool/>
          <VeltSidebarButton/>
          <div className="create-new-button">
              <button
                className="create-new-button__inner create-new-button__inner--transparent"
                data-qaid="create_new_button"
              >
                <span className="text-body-small create-new-button__text">
                  Create New
                </span>
                <span className="create-new-button__arrow">
                  <div
                    className="promo__icon create-new-button__icon Dark01-bg promo__icon--medium"
                    style={{
                      maskImage:
                        'url("https://ak03-cdn.slidely.com/static/promo-design-system/assets/img/Icons/20/ic20-chevron-down.svg?ver=1.3")'
                    }}
                  />
                </span>
              </button>
            </div>
            <a
              data-qaid="header_dashboard"
              href="/dashboard"
              className="links__item--dropdown__btn remove-small-screen projects"
            >
              My Workspace{" "}
            </a>
            <a
              data-qaid="header_dashboard"
              href="/dashboard"
              className="links__item--dropdown__btn remove-small-screen projects"
            >
              <YourAuthComponent/>
            </a>
      </div>
      
   



      
      <div className="sidebar">
        <input
          type="checkbox"
          id="sidebar-toggle"
          className="sidebar__checkbox"
        />
        <label htmlFor="sidebar-toggle" className="sidebar__button">
          <span className="sidebar__icon">&nbsp;</span>
        </label>
        <nav className="sidebar__nav">
          <div className="sidebar__list sidebar__list--first login logged-in">
            <ul>
              <li>
                <a href="/" className="sidebar__link">
                  Home
                </a>
              </li>
              <li>
                <div
                  className="sidebar__link open-secondary"
                  data-open="secondary-1"
                >
                  Create
                </div>
              </li>
              <li>
                <div
                  className="sidebar__link open-secondary"
                  data-open="secondary-2"
                >
                  Templates
                </div>
              </li>
              <li>
                <div
                  className="sidebar__link open-secondary"
                  data-open="secondary-3"
                >
                  Tools
                </div>
              </li>
              <li>
                <div
                  className="sidebar__link open-secondary"
                  data-open="secondary-4"
                >
                  Resources
                </div>
              </li>
              <li>
                <div
                  className="sidebar__link open-secondary"
                  data-open="secondary-5"
                >
                  Company
                </div>
              </li>
              <li>
                <a
                  className="sidebar__link promoai"
                  href="/promo-ai-social-media-manager?utm_content=site_header"
                >
                  PromoAI{" "}
                </a>
              </li>
              <li>
                <a href="/pricing" className="sidebar__link">
                  Pricing{" "}
                </a>
              </li>
              <li className="sidebar__item login-btn" style={{ display: "none" }}>
                <span className="">
                  <a href="/login" className="new-auth sidebar__link signin">
                    Login
                  </a>
                </span>
              </li>
              <li
                className="sidebar__item signup-btn"
                style={{ display: "none" }}
              >
                <a href="/signup" className="new-auth sidebar__link signup">
                  Sign Up
                </a>
              </li>
              <li className="sidebar__item logout-btn">
                <span className="sidebar__link logout">Sign Out</span>
              </li>
            </ul>
          </div>
          <button className="btn-hp btn-hp--round sidebar__start-btn create-button">
            Start now!
          </button>
        </nav>
        <nav className="sidebar__nav sidebar__nav--secondary secondary-1">
          <div className="sidebar__list">
            <div className="close-secondary">Create</div>
            <ul>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Social Media
                </div>
                <ul className="panel">
                  <li>
                    <a href="https://promo.com/tools/calendar/march">
                      Daily Calendar Videos
                    </a>
                  </li>
                  <li>
                    <a href="/for/facebook/videos">Facebook Videos</a>
                  </li>
                  <li>
                    <a href="/for/instagram/videos">Instagram Videos</a>
                  </li>
                  <li>
                    <a href="/for/youtube/videos">YouTube Videos</a>
                  </li>
                  <li>
                    <a href="/for/youtube/intros">YouTube Intro Videos</a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Industries
                </div>
                <ul className="panel">
                  <li>
                    <a href="/for/real-estate-videos¬">Real Estate Videos</a>
                  </li>
                  <li>
                    <a href="/for/fitness">Fitness Videos</a>
                  </li>
                  <li>
                    <a href="/for/fashion">Fashion Videos</a>
                  </li>
                  <li>
                    <a href="/for/restaurants">Restaurant Videos</a>
                  </li>
                  <li>
                    <a href="/for/travel">Travel Videos</a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Marketing
                </div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_black-friday-cyber-monday"
                      href="/for/commercials"
                    >
                      Commercial Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_halloween"
                      href="/for/facebook/story-ads"
                    >
                      Facebook Story Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_thanksgiving"
                      href="/for/instagram/story-ads"
                    >
                      Instagram Story Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_christmas"
                      href="/for/linkedin/ads"
                    >
                      LinkedIn Video Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_new-years"
                      href="/for/youtube/ads"
                    >
                      YouTube Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_new-years"
                      href="/for/promo-videos"
                    >
                      Promo Videos
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  E-commerce
                </div>
                <ul className="panel">
                  <li>
                    <a href="/for/ecommerce">E-commerce Ads</a>
                  </li>
                  <li>
                    <a href="/for/amazon/ads">Amazon Video Ads</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        <nav className="sidebar__nav sidebar__nav--secondary secondary-2">
          <div className="sidebar__list">
            <div className="close-secondary">Templates</div>
            <ul>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Trending Now
                </div>
                <ul className="panel">
                  <li>
                    <a data-qaid="header_submenu_winter" href="/templates/spring">
                      Spring
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_christmas"
                      href="/templates/womens-history"
                    >
                      Women's History Month
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_new-years"
                      href="/templates/easter"
                    >
                      Easter
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_valentines-day"
                      href="/templates/inspirational"
                    >
                      Motivational &amp; Inspirational
                    </a>
                  </li>
                  <li>
                    <a data-qaid="header_submenu_big-game" href="/templates/meme">
                      Memes
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Marketing
                </div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_templates-marketing-videos"
                      href="/templates/marketing-videos?aspect_ratio=all&sort_order=most_popular"
                    >
                      Sales &amp; Promotions
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-6-seconds"
                      href="/templates/6-seconds?aspect_ratio=all&sort_order=most_popular"
                    >
                      Short Ads
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-search"
                      href="/templates/search?aspect_ratio=all&keyword=slideshow&sort_order=most_popular"
                    >
                      Slideshows
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Industries
                </div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_templates-real-estate"
                      href="/templates/real-estate?aspect_ratio=all&sort_order=most_popular"
                    >
                      Real Estate
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-health-fitness"
                      href="/templates/health-fitness?aspect_ratio=all&sort_order=most_popular"
                    >
                      Health &amp; Fitness
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-beauty-care"
                      href="/templates/beauty-care?aspect_ratio=all&sort_order=most_popular"
                    >
                      Beauty &amp; Care
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-food-beverages"
                      href="/templates/food-beverages?aspect_ratio=all&sort_order=most_popular"
                    >
                      Food &amp; Drink
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-ecommerce-online-stores"
                      href="/templates/ecommerce-online-stores?aspect_ratio=all&sort_order=most_popular"
                    >
                      E-commerce &amp; Retail
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-recruiting-hr"
                      href="/templates/recruiting-hr?aspect_ratio=vertical&sort_order=most_popular"
                    >
                      Recruiting &amp; HR
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-search"
                      href="/templates/search?aspect_ratio=all&keyword=education&sort_order=most_popular"
                    >
                      Education
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Social Media
                </div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_facebook-ads"
                      href="/templates/facebook-ads?aspect_ratio=square&sort_order=most_popular"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-instagram-ads"
                      href="/templates/instagram-ads?aspect_ratio=square&sort_order=most_popular"
                    >
                      Instagram
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-search"
                      href="/templates/search?aspect_ratio=vertical&keyword=tiktok&sort_order=most_popular"
                    >
                      TikTok
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-youtube-ads"
                      href="/templates/youtube-ads?aspect_ratio=wide&sort_order=most_popular"
                    >
                      YouTube
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-vertical-videos"
                      href="/templates/vertical-videos?aspect_ratio=vertical&keyword=vertical%20video%20templates%2Cvertical%20video%20ad%20templates%2Cfacebook%20vertical%20video%20ads%20templates%2Cyoutube%20vertical%20video%20ads%20templates%2Cinstagram%20vertical%20video%20ads%20templates%2Cfblandingpage%2CSocial%20Marketing&sort_order=most_popular"
                    >
                      Stories
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">Formats</div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_templates-meme"
                      href="/templates/meme?aspect_ratio=all&sort_order=most_popular"
                    >
                      Meme Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-6-seconds"
                      href="/templates/6-seconds?aspect_ratio=all&sort_order=most_popular"
                    >
                      6 Second Videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-search"
                      href="/templates/search?aspect_ratio=all&keyword=youtube%20intro&sort_order=most_popular"
                    >
                      YouTube Intros
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-Listical"
                      href="/templates/Listical%20Videos%20?aspect_ratio=all&sort_order=most_popular"
                    >
                      Listicles
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_templates-inspirational"
                      href="/templates/inspirational?aspect_ratio=all&sort_order=most_popular"
                    >
                      Inspirational &amp; Quotes
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        <nav className="sidebar__nav sidebar__nav--secondary secondary-3">
          <div className="sidebar__list">
            <div className="close-secondary">Tools</div>
            <ul>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Video Maker
                </div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_online-video-maker"
                      href="/for/online-video-maker"
                    >
                      Online Video Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-photos-to-video-maker"
                      href="/tools/image-resizer/slideshow-maker"
                    >
                      Slideshow Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_for-youtube-intros"
                      href="/for/youtube/intros"
                    >
                      YouTube Intro Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-lyric-video-maker"
                      href="/tools/lyric-video-maker"
                    >
                      Lyric Video Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_for-video-ad-maker"
                      href="/for/video-ad-maker"
                    >
                      Video Ad Maker
                    </a>
                  </li>
                  <li>
                    <a data-qaid="header_submenu_tools" href="/tools">
                      All Tools
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Video Editor
                </div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_for_video-editor"
                      href="/for/video-editor"
                    >
                      Online Video Editor
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_add-audio-to-video"
                      href="/tools/add-audio-to-video"
                    >
                      Add Audio to Video
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_online-video-cutter"
                      href="/tools/online-video-cutter"
                    >
                      Online Video Cutter
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_online-mp4-editor"
                      href="/tools/online-mp4-editor"
                    >
                      Online MP4 Editor
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_video-compressor"
                      href="/tools/video-compressor"
                    >
                      Video Compressor
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_add-text-to-video"
                      href="/tools/add-text-to-video"
                    >
                      Add Text to Video
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">Photos</div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_tools-image-resizer"
                      href="/tools/image-resizer"
                    >
                      Image Resizer
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-collage-maker"
                      href="/tools/collage-maker"
                    >
                      Free Online Collage Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-image-resizer-slideshow-maker"
                      href="/tools/photos-to-video-maker"
                    >
                      Photos to Video Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_/tools-youtube-thumbnail-maker"
                      href="/tools/youtube-thumbnail-maker"
                    >
                      YouTube Thumbnail Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-montage-maker"
                      href="/tools/montage-maker"
                    >
                      Montage Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-meme-maker"
                      href="tools-meme-maker"
                    >
                      Meme Maker
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">GIF</div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="header_submenu_tools-video-to-gif"
                      href="/tools/video-to-gif"
                    >
                      Video to GIF Maker
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-add-text-to-gif"
                      href="/tools/add-text-to-gif"
                    >
                      Add Text to GIF
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-gif-editor"
                      href="/tools/gif-editor"
                    >
                      GIF Editor
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-happy-birthday-gif-maker"
                      href="/tools/happy-birthday-gif-maker"
                    >
                      Happy Birthday GIF
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-merry-christmas-gif-maker"
                      href="/tools/merry-christmas-gif-maker"
                    >
                      Merry Christmas GIF
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">More</div>
                <ul className="panel">
                  <li>
                    <a href="https://promo.com/tools/calendar/march">
                      Social Media Calendar
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-video-production-cost-estimator"
                      href="/tools/video-production-cost-estimator"
                    >
                      Video Production Cost Estimator
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-facebook-ad-budget-calculator"
                      href="/tools/facebook-ad-budget-calculator"
                    >
                      Facebook Ad Budget Calculator
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-facebook-ads-troubleshooter"
                      href="/tools/facebook-ads-troubleshooter"
                    >
                      Facebook Ads Troubleshooter
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_tools-youtube-money-calculator"
                      href="/tools/youtube-money-calculator"
                    >
                      YouTube Money Calculator
                    </a>
                  </li>
                  <li>
                    <a data-qaid="header_submenu_tools-ebook" href="/tools/ebook">
                      Promo Marketing Ebook
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        <nav className="sidebar__nav sidebar__nav--secondary secondary-4">
          <div className="sidebar__list">
            <div className="close-secondary">Resources</div>
            <ul>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">Learn</div>
                <ul className="panel">
                  <li>
                    <a data-qaid="header_submenu_blog" href="/blog">
                      Blog
                    </a>
                  </li>
                  <li>
                    <a data-qaid="header_submenu_learn" href="/learn">
                      Promo Academy
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_support-promo"
                      href="https://support.promo.com/en"
                      target="_blank"
                    >
                      Knowledge Base
                    </a>
                  </li>
                  <li>
                    <a data-qaid="header_submenu_faq" href="/faq">
                      FAQ
                    </a>
                  </li>
                </ul>
              </li>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item">
                  Tips &amp; Tutorials
                </div>
                <ul className="panel">
                  <li>
                    <a
                      data-qaid="/blog/video-marketing-101"
                      href="/blog/video-marketing-101"
                    >
                      Video Marketing 101
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_guide-to-creating-winning-videos"
                      href="/blog/guide-to-creating-winning-videos"
                    >
                      How to create winning videos
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_blog-video-templates-what-they-are-and-why-you-need-them"
                      href="/blog/7-things-you-didnt-know-you-can-do-with-promo"
                    >
                      7 Things You Could Do With Promo
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_social-media-image-sizes"
                      href="/blog/how-to-add-music-to-a-video"
                    >
                      How to Add Music to a Video
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_a-complete-guide-to-video-aspect-ratios-in-2021"
                      href="/blog/how-to-add-subtitles-to-a-video"
                    >
                      How to Add Subtitles to a Video
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_a-complete-guide-to-video-aspect-ratios-in-2021"
                      href="/blog/a-complete-guide-to-video-aspect-ratios-in-2021"
                    >
                      The Complete Guide to Video Aspect Ratios
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        <nav className="sidebar__nav sidebar__nav--secondary secondary-5">
          <div className="sidebar__list">
            <div className="close-secondary">Company</div>
            <ul>
              <li className="sidebar__item">
                <div className="sidebar__link title accordion__item active">
                  More About Promo.com
                </div>
                <ul className="panel">
                  <li>
                    <a data-qaid="header_submenu_about" href="/about">
                      About
                    </a>
                  </li>
                  <li>
                    <a data-qaid="header_submenu_careers" href="/careers">
                      Careers
                    </a>
                  </li>
                  <li>
                    <a data-qaid="blog" href="/blog">
                      Blog
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_promodotcom"
                      href="https://www.facebook.com/promodotcom"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_instagram-promodotcom"
                      href="https://www.instagram.com/promodotcom"
                    >
                      Instagram
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_linkedin-company-promodotcom-mycompany"
                      href="https://www.linkedin.com/company/promodotcom/mycompany"
                    >
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_twitter-Promodotcom"
                      href="https://twitter.com/Promodotcom"
                    >
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_youtube-channel"
                      href="https://www.youtube.com/channel/UC0d_7BlGBgDcf62o766FkPQ/featured"
                    >
                      YouTube
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_vimeo-promobyslidely"
                      href="https://vimeo.com/promobyslidely"
                    >
                      Vimeo
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_terms-of-service"
                      href="/terms-of-service"
                    >
                      Terms of Service
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_privacy-policy"
                      href="/privacy-policy"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      data-qaid="header_submenu_cookies-policy"
                      href="/cookies-policy"
                    >
                      Cookies Policy
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        <nav className="sidebar__nav sidebar__nav--secondary secondary-6">
          <div className="sidebar__list">
            <div className="close-secondary">Follow</div>
          </div>
        </nav>
      </div>
      <div className="out-of-projects-links">
        <a className="back-btn desktop" href="/create">
          Back to my account
        </a>
        <a className="back-btn mobile" href="/">
          Back
        </a>
      </div>
    </header>
    <div id="mobile-auth-container">
      <div className="MobileMenu MobileMenu--auth ">
        <div className="MobileMenuToggle open">
          <div className="MobileMenuToggle__icon">
            <span className="MobileMenuToggle__line" />
            <span className="MobileMenuToggle__line" />
          </div>
        </div>
        <div className="MobileMenu__content login" />
      </div>
    </div>
    <div id="switch-to-annual-popup" />
    <div id="get-more-downloads-popup" />
    <div className="pricing-popup-wrap" />
    <div id="top-bar-notification">
      <section className="exceed-notification-box hide-exceed-notification-box">
        <div className="image-selected-text">
          You've exceeded your draft limit. Upgrade your plan to enjoy more
          drafts.
        </div>
        <aside>
          <div role="button" className="exceed-button">
            Upgrade Now
          </div>
          <div role="button" className="x-button" />
        </aside>
      </section>
    </div>
    <div className="popup-manager-container" />
    <div id="upgrade-strip-container" />
    <section id="layout-content" className="new-plans-v3  auto-height">
      <div className="view-container share white-theme">
        <div className="header-patch" />
        <div className="video-viewer-container">
          <div
            className="video-viewer viewer-ratio-wide"
            itemScope=""
            itemType="http://schema.org/ItemPage"
          >
            <div className="viewer-header">
              <div className="share">
                <div
                  className="logo-white-label-wrapper"
                  style={{ display: "none" }}
                >
                  <img src="https://promo.com/share/65e905b9f40e455e11747bc2?utm_source=old_share_page_share_dialog" />
                </div>
                <div className="logo-image-wrapper show-default">
                  <div className="default-logo">
                    {/*?xml version="1.0" encoding="UTF-8"?*/}
                    <svg
                      width="22px"
                      height="26px"
                      viewBox="0 0 22 26"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                      {/* Generator: sketchtool 52.5 (67469) - http://www.bohemiancoding.com/sketch */}
                      <title>F21EF66B-AC70-4761-BD58-0CF80940AF0E</title>
                      <desc>Created with sketchtool.</desc>
                      <defs>
                        <linearGradient
                          x1="0.00537998663%"
                          y1="49.9970053%"
                          x2="100.036289%"
                          y2="49.9970053%"
                          id="linearGradient-1"
                        >
                          <stop stopColor="#FF3176" offset="0%" />
                          <stop stopColor="#FF7369" offset="100%" />
                        </linearGradient>
                        <linearGradient
                          x1="48.5798817%"
                          y1="54.2967493%"
                          x2="55.1676529%"
                          y2="34.4061796%"
                          id="linearGradient-2"
                        >
                          <stop stopColor="#FFFFFF" offset="0%" />
                          <stop stopColor="#000000" offset="100%" />
                        </linearGradient>
                      </defs>
                      <g
                        id="Page-1"
                        stroke="none"
                        strokeWidth={1}
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          id="Share-Collection-Page"
                          transform="translate(-428.000000, -134.000000)"
                        >
                          <g
                            id="logo"
                            transform="translate(428.000000, 134.000000)"
                          >
                            <path
                              d="M20.2986321,10.9688889 L3.64248989,0.458888889 C2.93397974,0.0108924108 2.04660609,-0.00636245151 1.32230058,0.413773117 C0.597995072,0.833908685 0.149820407,1.62585232 0.150471698,2.48444444 L0.150471698,14.6233333 C0.132465611,15.4836852 0.56615818,16.2867701 1.28404255,16.7224094 C2.00192692,17.1580487 2.89162767,17.1580487 3.60951203,16.7224094 C4.3273964,16.2867701 4.76108897,15.4836852 4.74308288,14.6233333 L4.74308288,6.71444444 L7.45802224,8.42777778 L12.9061725,11.8655556 L12.935192,11.8844444 L14.7365532,13.0211111 L10.3997439,15.8311111 L8.52852089,17.0422222 C7.79949217,17.4755559 7.35782454,18.2861166 7.37715348,19.1552437 C7.39648242,20.0243707 7.87371725,20.8130913 8.62123974,21.2113308 C9.36876222,21.6095703 10.267044,21.5536505 10.962938,21.0655556 L20.3136792,15.0055556 C20.9876242,14.5689795 21.3949851,13.8029055 21.3903879,12.9807208 C21.3857907,12.158536 20.9698904,11.3973815 20.2911085,10.9688889 L20.2986321,10.9688889 Z M2.51502695,20.9288889 C1.54073252,20.928889 0.662393628,21.5356783 0.289647775,22.466264 C-0.0830980782,23.3968496 0.123170463,24.4679301 0.812254393,25.1799777 C1.50133832,25.8920252 2.53750581,26.1047847 3.43751166,25.7190299 C4.3375175,25.3332751 4.92408368,24.4249898 4.92364892,23.4177778 C4.92187147,22.0435305 3.84436182,20.930113 2.51502695,20.9288889 Z"
                              fill="url(#linearGradient-1)"
                              fillRule="nonzero"
                            />
                            <polygon
                              id="Path"
                              fill="url(#linearGradient-2)"
                              points="12.9061725 11.8655556 7.45802224 8.42777778 7.45694744 8.41333333"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
                <h1
                  className="title"
                  id="item-name"
                  itemProp="name"
                  title="My Promo video"
                  style={{ display: "inline-block" }}
                >
                  My Promo video
                </h1>
                
              </div>
              
            </div>
            <div style={{marginTop:"8px"}}>
              <VeltVideoPlayer src="https://ak03-video-cdn.slidely.com/promoVideos/videos/65/e9/65e905b9f40e455e11747bc2/preview.mp4?dv=1"/>
            </div>

        
            <div className="published-placeholder-container" />
            <section className="box-for-lp-collection-buttons show">
              <aside className="buttons-left">
                <div
                  id="share-video-viewer-button"
                  className="pr-preview-btn btn-secondary"
                >
                  Share
                </div>
              </aside>
              <aside className="buttons-right">
                <div
                  id="see-more-video-viewer-button"
                  className="pr-preview-btn btn-secondary"
                >
                  More Videos
                </div>
                <div
                  id="customize-video-viewer-button"
                  className="pr-primary-btn btn-primary"
                  data-button-text="bottom"
                >
                  Customize
                </div>
              </aside>
            </section>
            <div className="ratios-menu-container-wrapper">
              <div className="ratios-menu-container" />
            </div>
            <div className="viewer-footer">
              <div className="published-actions">
                <button className="promo-button published-actions__button published-actions__button--createBtn">
                  Create New
                </button>
                <button className="promo-button published-actions__button published-actions__button--shareBtn">
                  Share
                </button>
                <div className="published-actions__primary">
                  <button
                    className="PromoUI Button Button--primary"
                    id="publish_v2_button"
                    style={{ display: "none" }}
                  >
                    Republish
                  </button>
                  <a
                    className="promo-button promo-button--primary published-actions__button published-actions__button--publishBtn"
                    href="#"
                  >
                    Republish{" "}
                  </a>
                  <a
                    className="promo-button promo-button--primary published-actions__button shareBtn-facebookBtn"
                    href="#"
                  >
                    Post to Facebook
                  </a>
                </div>
              </div>
              <div className="action-options">
                <button className="createBtn">Create new</button>
                <form id="downloadForm" method="get" action="">
                  <span type="submit" id="downloadBtn">
                    Download
                  </span>
                  <span className="download-menu-button" />
                  <div className="download-menu">
                    <a className="dm-link dm-download-video">Download Video</a>
                    <a className="dm-link dm-download-FB-Cover">
                      Download FB Cover
                    </a>
                  </div>
                </form>
                <form id="downloadFbCoverForm" method="get" action="" />
              </div>
            </div>
          </div>
        </div>
        <div itemProp="description" id="item-description" className="description">
          <div className="des-title">Description: </div>
          <div className="text">
            My Promo video - Easily create awesome marketing videos to help you
            grow your business online with this beautiful marketing video
            template. Use Promo.com's award-winning online video maker and editor
            to make high-quality videos using professional footage and ready-made
            templates like this one. Add your text and logo, choose from millions
            of premium stock footage clips, high-quality photos and royalty-free
            music in the Promo library or upload your own content. Try for free!{" "}
          </div>
        </div>
        <div className="tags-container">
          <div className="tags">
            <div className="des-title">Trending video searches: </div>
            <div className="list">
              <ul>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Activity&mode=search&utm_content=tagsinshare"
                  >
                    Activity{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Affectionate&mode=search&utm_content=tagsinshare"
                  >
                    Affectionate{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Backgrounds&mode=search&utm_content=tagsinshare"
                  >
                    Backgrounds{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Beautiful People&mode=search&utm_content=tagsinshare"
                  >
                    Beautiful People{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Beauty&mode=search&utm_content=tagsinshare"
                  >
                    Beauty{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Beauty In Nature&mode=search&utm_content=tagsinshare"
                  >
                    Beauty In Nature{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Carefree&mode=search&utm_content=tagsinshare"
                  >
                    Carefree{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Cheerful&mode=search&utm_content=tagsinshare"
                  >
                    Cheerful{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Child&mode=search&utm_content=tagsinshare"
                  >
                    Child{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Childhood&mode=search&utm_content=tagsinshare"
                  >
                    Childhood{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Close-up&mode=search&utm_content=tagsinshare"
                  >
                    Close-up{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Cute&mode=search&utm_content=tagsinshare"
                  >
                    Cute{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Daughter&mode=search&utm_content=tagsinshare"
                  >
                    Daughter{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Day&mode=search&utm_content=tagsinshare"
                  >
                    Day{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Enjoyment&mode=search&utm_content=tagsinshare"
                  >
                    Enjoyment{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Females&mode=search&utm_content=tagsinshare"
                  >
                    Females{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Film&mode=search&utm_content=tagsinshare"
                  >
                    Film{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Fun&mode=search&utm_content=tagsinshare"
                  >
                    Fun{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Girls&mode=search&utm_content=tagsinshare"
                  >
                    Girls{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Grass&mode=search&utm_content=tagsinshare"
                  >
                    Grass{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Happiness&mode=search&utm_content=tagsinshare"
                  >
                    Happiness{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Horizontal&mode=search&utm_content=tagsinshare"
                  >
                    Horizontal{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Human Body Part&mode=search&utm_content=tagsinshare"
                  >
                    Human Body Part{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Human Face&mode=search&utm_content=tagsinshare"
                  >
                    Human Face{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Innocence&mode=search&utm_content=tagsinshare"
                  >
                    Innocence{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Joy&mode=search&utm_content=tagsinshare"
                  >
                    Joy{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Lifestyles&mode=search&utm_content=tagsinshare"
                  >
                    Lifestyles{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Motion&mode=search&utm_content=tagsinshare"
                  >
                    Motion{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Nature&mode=search&utm_content=tagsinshare"
                  >
                    Nature{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Outdoors&mode=search&utm_content=tagsinshare"
                  >
                    Outdoors{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Park - Man Made Space&mode=search&utm_content=tagsinshare"
                  >
                    Park - Man Made Space{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=People&mode=search&utm_content=tagsinshare"
                  >
                    People{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Playful&mode=search&utm_content=tagsinshare"
                  >
                    Playful{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Playground&mode=search&utm_content=tagsinshare"
                  >
                    Playground{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Portrait&mode=search&utm_content=tagsinshare"
                  >
                    Portrait{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Preschool&mode=search&utm_content=tagsinshare"
                  >
                    Preschool{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Preschool Building&mode=search&utm_content=tagsinshare"
                  >
                    Preschool Building{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Recreational Pursuit&mode=search&utm_content=tagsinshare"
                  >
                    Recreational Pursuit{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Sky&mode=search&utm_content=tagsinshare"
                  >
                    Sky{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Smiling&mode=search&utm_content=tagsinshare"
                  >
                    Smiling{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Summer&mode=search&utm_content=tagsinshare"
                  >
                    Summer{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Sun&mode=search&utm_content=tagsinshare"
                  >
                    Sun{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Sunlight&mode=search&utm_content=tagsinshare"
                  >
                    Sunlight{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Sunny&mode=search&utm_content=tagsinshare"
                  >
                    Sunny{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Sweet Food&mode=search&utm_content=tagsinshare"
                  >
                    Sweet Food{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Swing&mode=search&utm_content=tagsinshare"
                  >
                    Swing{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Swinging&mode=search&utm_content=tagsinshare"
                  >
                    Swinging{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Toddler&mode=search&utm_content=tagsinshare"
                  >
                    Toddler{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=USA&mode=search&utm_content=tagsinshare"
                  >
                    USA{" "}
                  </a>
                </li>
                <li itemProp="keywords">
                  <a
                    target="_blank"
                    href="/create?keyword=Using A Swing&mode=search&utm_content=tagsinshare"
                  >
                    Using A Swing{" "}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="see-more-tags">
            <span className="less">See less</span>
            <span className="more">See more</span>
          </div>
        </div>
      </div>
    </section>
    <div id="fb-root" className=" fb_reset">
      <div style={{ position: "absolute", top: "-10000px", width: 0, height: 0 }}>
        <div />
      </div>
    </div>
    <footer className="footer  ">
      <div data-qaid="footer" className="footer__links accordion__list">
        <div className="footer__item__container">
          <div className="footer__item accordion__item">Company</div>
          <ul className="panel">
            <li>
              <a data-qaid="footer_pricing" href="/pricing">
                Pricing
              </a>
            </li>
            <li>
              <a data-qaid="footer_about" href="/about">
                About
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_careers"
                href="https://promo.com/careers"
                target="_blank"
              >
                Careers
              </a>
            </li>
            <li>
              <a data-qaid="footer_news" href="/news">
                News &amp; Media
              </a>
            </li>
            <li>
              <a data-qaid="footer_affiliates" href="/cat/affiliates">
                Affiliates
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_write_for_us"
                className="external-link"
                data-link-location="footer"
                href="https://promo.com/blog/write-for-us"
                target="_blank"
              >
                Write for Us
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__item__container">
          <div className="footer__item accordion__item">Support</div>
          <ul className="panel">
            <li>
              <a data-qaid="footer_faq" href="/faq">
                FAQ
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_knowledge_base"
                href="https://support.promo.com/en/"
              >
                Knowledge Base
              </a>
            </li>
            <li>
              <a data-qaid="footer_contact_us" href="mailto:support@promo.com">
                Contact Us
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_blog"
                href="https://promo.com/blog"
                data-linkname="blog"
                data-where="footer"
                target="_blank"
              >
                Blog
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__item__container">
          <div className="footer__item accordion__item">Product</div>
          <ul className="panel">
            <li>
              <a
                data-qaid="footer_for_promoai"
                href="/promo-ai-social-media-manager?utm_content=site_footer"
                target="_blank"
              >
                PromoAI
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_promo"
                href="/for/promo-videos"
                target="_blank"
              >
                Promo Video Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_commercial"
                href="/for/commercials"
                target="_blank"
              >
                Commercial Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_social"
                href="/for/social-media-videos"
                target="_blank"
              >
                Social Media Video Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_ecommerce"
                href="/for/ecommerce"
                target="_blank"
              >
                eCommerce Ads
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_fb_video_maker"
                href="/for/facebook/videos"
                target="_blank"
              >
                Facebook Video Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_fb_video_ad_creator"
                href="/for/facebook/ads"
                target="_blank"
              >
                Facebook Video Ad Creator
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_fb_story_ads"
                href="/for/facebook/story-ads"
                target="_blank"
              >
                Facebook Story Ads
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_ig_video_maker"
                href="/for/instagram/videos"
                target="_blank"
              >
                Instagram Video Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_ig_video_ad_maker"
                href="/for/instagram/ads"
                target="_blank"
              >
                Instagram Video Ad Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_ig_story_ads"
                href="/for/instagram/story-ads"
                target="_blank"
              >
                Instagram Story Ads
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_yt_video_maker"
                href="/for/youtube/videos"
                target="_blank"
              >
                YouTube Video Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_yt_ad_maker"
                href="/for/youtube/ads"
                target="_blank"
              >
                YouTube Ad Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_yt_intro_maker"
                href="/for/youtube/intros"
                target="_blank"
              >
                YouTube intro Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_yt_outro_maker"
                href="/for/youtube/outros"
                target="_blank"
              >
                YouTube Outro Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_li_video_ads"
                href="/for/linkedin/ads"
                target="_blank"
              >
                LinkedIn Video Ads
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_tw_video_ads"
                href="/for/twitter/ads"
                target="_blank"
              >
                Twitter Video Ads
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_amazon_video_ads"
                href="/for/amazon/ads"
                target="_blank"
              >
                Amazon Video Ads
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_real_estate_videos"
                href="/for/real-estate-videos"
                target="_blank"
              >
                Real Estate Videos
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_fitness_marketing_videos"
                href="/for/fitness"
                target="_blank"
              >
                Fitness Marketing Videos
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_fashion_marketing_videos"
                href="/for/fashion"
                target="_blank"
              >
                Fashion Marketing Videos
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_restaurant_videos"
                href="/for/restaurants"
                target="_blank"
              >
                Restaurant Videos
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_beauty_marketing_videos"
                href="/for/beauty"
                target="_blank"
              >
                Beauty Marketing Videos
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_travel_ads"
                href="/for/travel"
                target="_blank"
              >
                Travel Ads
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_business"
                href="/for/business"
                target="_blank"
              >
                Business
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_for_nonprofit"
                href="/for/nonprofit"
                target="_blank"
              >
                Nonprofit Videos
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__item__container">
          <div className="footer__item accordion__item">Tools</div>
          <ul className="panel">
            <li>
              <a data-qaid="footer_tool" href="/tools" target="_blank">
                All Tools
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_photos_to_video"
                href="/tools/photos-to-video-maker"
                target="_blank"
              >
                Photos to video maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_video_maker"
                href="/for/online-video-maker"
                target="_blank"
              >
                Online Video Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_ad_maker"
                href="/for/video-ad-maker"
                target="_blank"
              >
                Video Ad Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_calendar"
                className="calendar"
                href="https://promo.com/tools/calendar/march"
                data-link-location="footer"
                target="_blank"
              >
                Social Media Calendar
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_resizer"
                href="/tools/image-resizer"
                target="_blank"
              >
                Image Resizer
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_free-photo-editor"
                href="/tools/free-photo-editor"
                target="_blank"
              >
                Free Photo Editor
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_collage"
                href="/tools/collage-maker"
                target="_blank"
              >
                Free Online Collage Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_fb_covers"
                href="/tools/facebook-video-covers"
                target="_blank"
              >
                Facebook Video Covers
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_video_production"
                href="/tools/video-production-cost-estimator"
                target="_blank"
              >
                Video Production Cost Estimator
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_fb_ad_budget"
                href="/tools/facebook-ad-budget-calculator"
                target="_blank"
              >
                Facebook Ad Budget Calculator
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_fb_ads_trouble"
                href="/tools/facebook-ads-troubleshooter"
                target="_blank"
              >
                Facebook Ads Troubleshooter
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_yt_calc"
                href="/tools/youtube-money-calculator"
                target="_blank"
              >
                YouTube Money Calculator
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_online-mp4-editor"
                href="/tools/online-mp4-editor"
                target="_blank"
              >
                MP4 Editor
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_add-music-to-video"
                href="/tools/add-music-to-video"
                target="_blank"
              >
                Add Music to Video
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_video-to-gif"
                href="/tools/video-to-gif"
                target="_blank"
              >
                Video to GIF Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_add-text-to-gif"
                href="/tools/add-text-to-gif"
                target="_blank"
              >
                Add Text to GIF
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_video-editor-for-youtube"
                href="/tools/video-editor-for-youtube"
                target="_blank"
              >
                Video Editor for YouTube
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_meme-maker"
                href="/tools/meme-maker"
                target="_blank"
              >
                Meme Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_birthday-video-maker"
                href="/tools/birthday-video-maker"
                target="_blank"
              >
                Birthday Video Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_online-video-cutter"
                href="/tools/online-video-cutter"
                target="_blank"
              >
                Online Video Cutter
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_lyric-video-maker"
                href="/tools/lyric-video-maker"
                target="_blank"
              >
                Lyric Video Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_add-audio-to-video"
                href="/tools/add-audio-to-video"
                target="_blank"
              >
                Add Audio to Video
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_add-text-to-video"
                href="/tools/add-text-to-video"
                target="_blank"
              >
                Add Text to Video
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_gif-editor"
                href="/tools/gif-editor"
                target="_blank"
              >
                GIF Editor
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_video-merger"
                href="/tools/video-merger"
                target="_blank"
              >
                Video Merger
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_video-compressor"
                href="/tools/video-compressor"
                target="_blank"
              >
                Video Compressor
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_video-resizer"
                href="/tools/video-resizer"
                target="_blank"
              >
                Video Resizer
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_youtube-thumbnail-maker"
                href="/tools/youtube-thumbnail-maker"
                target="_blank"
              >
                Youtube Thumbnail Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_video-trimmer"
                href="/tools/video-trimmer"
                target="_blank"
              >
                Video Trimmer
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_add_subtitles_to_video"
                href="/tools/add-subtitles-to-video"
                target="_blank"
              >
                Add Subtitles to Video
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_montage-maker"
                href="/tools/montage-maker"
                target="_blank"
              >
                Montage Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_video-cropper"
                href="/tools/video-cropper"
                target="_blank"
              >
                Video Cropper
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_slideshow-maker"
                href="/tools/slideshow-maker"
                target="_blank"
              >
                Slideshow Maker
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_tool_tkitok-stories"
                href="/tools/tiktok-video-editor"
                target="_blank"
              >
                TikTok Video Editor
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer__data">
        <div className="footer__info">
          <div className="footer__info__logo logo">
            <div alt="promo logo" className="promo-logo" />
          </div>
          <p className="footer__info__text">
            Promo.com is the #1 video creation platform for businesses and
            agencies. We help our users create loads of visual content and
            unlimited videos to promote anything they want effectively.
          </p>
          <div className="fmp-badges">
            <a
              data-qaid="footer_fb_partner"
              className="fmp-badge-fb external-link"
              data-linkname="facebook partner"
              data-where="footer"
              target="_blank"
              href="https://www.facebook.com/business/partner-directory/details?id=506062503095739"
            >
              <img
                srcSet="https://ak04-promo-cdn.slidely.com/images/promoVideos/homepage/partners/x1/meta.png/1709726050   1x,https://ak01-promo-cdn.slidely.com/images/promoVideos/homepage/partners/x2/meta.png/1709726050  2x"
                src="https://ak01-promo-cdn.slidely.com/images/promoVideos/homepage/partners/x2/meta.png/1709726050"
              />
            </a>
            <a
              data-qaid="footer_ig_partner"
              className="fmp-badge-instagram external-link"
              data-linkname="instagram partner"
              data-where="footer"
              target="_blank"
              href="https://www.facebook.com/business/partner-directory/details?id=506062503095739&"
            >
              <svg
                width="38px"
                height="50px"
                viewBox="0 0 38 50"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <title>3AF09622-8C22-4B09-AB8C-18C70844F431</title>
                <desc>Created with sketchtool.</desc>
                <g
                  id="Footer-Design-25.12"
                  stroke="none"
                  strokeWidth={1}
                  fill="none"
                  fillRule="evenodd"
                >
                  <g id="Assets" transform="translate(-284.000000, -29.000000)">
                    <g id="Group-9" transform="translate(285.000000, 30.000000)">
                      <path
                        d="M13.6580126,38.7999814 C14.3847364,38.7999814 14.6958852,39.0830048 14.720803,39.6536437 L14.7218086,39.7803274 L14.7218086,40.6315744 C14.7218086,40.7897208 14.7469742,40.8292574 14.8818619,40.8435173 L14.9466351,40.8483533 L14.8972739,41.3074618 C14.462978,41.3539375 14.237462,41.2457363 14.1287545,41.0506983 L14.0967188,40.9825625 L14.0746534,40.9825625 C13.8937003,41.1888521 13.6743615,41.3332816 13.361788,41.3332816 C12.9066472,41.3332816 12.577639,41.0393123 12.577639,40.6625044 C12.577639,40.2498936 12.8788263,39.8963677 13.8788603,39.8261572 L14.0746534,39.8163676 L14.0746534,39.7596178 C14.0746534,39.4398286 13.932086,39.3056194 13.5701513,39.3056194 C13.3639717,39.3056194 13.122707,39.3749886 12.8968885,39.4766843 L12.7312104,39.5584384 L12.5997329,39.0786202 C12.9199276,38.8989321 13.2852126,38.8027547 13.6580126,38.7999814 Z M18.2472353,38.3354937 L18.2362598,38.8927713 L18.9490966,38.8927713 L18.9326333,39.3932992 L18.1978455,39.3932992 L18.1649761,40.492255 C18.1592597,40.714144 18.2800475,40.8174233 18.4993863,40.8174233 C18.5892982,40.8147552 18.6785138,40.8030082 18.7655136,40.7824607 L18.8941618,40.745074 L18.9820231,41.2404917 C18.793693,41.3033841 18.5951221,41.3347875 18.3952904,41.3332816 C17.8708768,41.3332816 17.5780499,41.1331465 17.5564911,40.6458783 L17.5563495,40.5282952 L17.5947352,39.4086297 L17.1999025,39.3674794 L17.2163658,38.9804511 L17.6111985,38.8618414 L17.6221169,38.3354937 L18.2472353,38.3354937 Z M23.3680845,38.7999814 C24.037105,38.7999814 24.409958,39.1816305 24.409958,39.764728 C24.4097358,39.8988006 24.3913132,40.0322973 24.3551376,40.1619766 C24.3499624,40.1619766 22.9118732,40.180017 22.720151,40.1824223 L22.6991212,40.1826862 L22.6991212,40.1982857 C22.7265599,40.585045 23.0062069,40.8483533 23.4558314,40.8483533 C23.6791262,40.8449481 23.8983481,40.7963444 24.0988401,40.7065658 L24.2454682,40.6315744 L24.3276703,41.1372124 C24.0865234,41.2612013 23.7519417,41.3332816 23.4119865,41.3332816 C22.6004273,41.3332816 22.0630844,40.8483533 22.0630844,40.0898962 C22.0630844,39.3158397 22.6113742,38.7999814 23.3680845,38.7999814 Z M26.1423744,38.7999814 C26.2605331,38.797925 26.3774817,38.8184796 26.4862596,38.8599674 L26.5920561,38.9083708 L26.4494602,39.4551592 C26.3391162,39.3959017 26.2145913,39.3639745 26.087554,39.3623692 C25.8908808,39.3623692 25.7067904,39.4651231 25.5499691,39.6843247 L25.4844152,39.7854376 L25.4844152,41.2560912 L24.8373743,41.2560912 L24.8373743,38.8927713 L25.4844152,38.8050916 L25.4844152,39.1921198 C25.6433886,38.9393008 25.8462642,38.7999814 26.1423744,38.7999814 Z M10.9385431,38.0310351 C11.8872677,38.0310351 12.3533555,38.4799233 12.3533555,39.1095502 C12.3533555,39.8059791 11.8762833,40.1941589 11.0575567,40.2443932 L10.8892962,40.2499253 L10.4999798,40.2550355 L10.4999798,41.2560912 L9.83095931,41.2560912 L9.83095931,38.0310351 L10.9385431,38.0310351 Z M16.5803005,38.7999814 C16.6984591,38.797925 16.8154077,38.8184796 16.9241856,38.8599674 L17.0299821,38.9083708 L16.8873862,39.4551592 C16.7770422,39.3959017 16.6525174,39.3639745 16.52548,39.3623692 C16.3288068,39.3623692 16.1447164,39.4651231 15.9878952,39.6843247 L15.9223412,39.7854376 L15.9223412,41.2560912 L15.2753004,41.2560912 L15.2753004,38.8927713 L15.9223412,38.8050916 L15.9223412,39.1921198 C16.0813147,38.9393008 16.2842188,38.7999814 16.5803005,38.7999814 Z M20.835113,38.7999814 C21.3058201,38.7999814 21.5990112,39.063756 21.6413323,39.506054 L21.6466436,39.6202984 L21.6466436,41.2560912 L20.9996313,41.2560912 L20.9996313,39.8061472 C20.9996313,39.4551592 20.8515762,39.3365494 20.5609252,39.3365494 C20.3735221,39.3365494 20.197651,39.4118198 20.0712396,39.5025926 L20.0016313,39.5584384 L20.0016313,41.2560912 L19.3545904,41.2560912 L19.3545904,38.8876612 L20.0016313,38.8050916 L20.0016313,39.1816305 C20.2264578,38.9495211 20.5280272,38.7999814 20.835113,38.7999814 Z M14.0747677,40.1364257 C13.444133,40.208506 13.2138758,40.3271158 13.2138758,40.5799348 C13.2138758,40.7606735 13.3619023,40.8895036 13.5921881,40.8895036 C13.7400055,40.8888499 13.8819517,40.8406786 13.9953889,40.7546668 L14.0747677,40.683214 L14.0747677,40.1364257 Z M23.3186661,39.2590899 C22.997941,39.2590899 22.7926723,39.4806482 22.7308432,39.7392634 L22.7155844,39.8265879 L23.8011886,39.8214778 L23.8011886,39.7803274 C23.8011886,39.4602693 23.6530763,39.2590899 23.3186661,39.2590899 Z M10.8948697,38.5573827 L10.4890043,38.5573827 L10.4890043,39.733798 L10.9166778,39.7235776 C11.4266676,39.7130883 11.6843921,39.5067988 11.6843921,39.1302598 C11.6843921,38.7534519 11.4211513,38.5573827 10.8948697,38.5573827 Z M18.986653,33.4450892 C19.1711058,33.4478219 19.3536551,33.4771291 19.5280236,33.5316938 L19.6994326,33.594629 L20.3794001,33.5378792 L20.4067817,34.069337 L19.9242592,33.9921465 C19.9900837,34.0591167 20.0394449,34.2395864 20.0394449,34.3635753 C20.0394449,34.8485037 19.6062265,35.2304217 18.9811081,35.2304217 C18.8645281,35.2310815 18.7483723,35.217153 18.6356938,35.1890025 C18.5479468,35.2202014 18.4382774,35.2973919 18.4382774,35.395561 C18.4382774,35.5100766 18.5291755,35.5678524 18.8344273,35.5792777 L18.9591856,35.5814098 L19.2224837,35.5814098 C19.946296,35.5814098 20.3575919,35.7720999 20.3575919,36.2365876 C20.3575919,36.7989754 19.6831123,37.1860037 18.8825571,37.1860037 C18.2135938,37.1860037 17.6816815,36.9538943 17.6816815,36.5254468 C17.6816815,36.2777379 17.8735815,36.0558489 18.2519509,35.9993681 C18.0326121,35.9270188 17.8681223,35.777479 17.868008,35.58652 C17.868008,35.3697412 18.0544203,35.1736719 18.3340672,35.0859922 C18.0544203,34.9517829 17.8734672,34.6833644 17.8734672,34.353355 C17.8734672,33.8630475 18.2847632,33.4450892 18.986653,33.4450892 Z M18.5864469,36.0816687 C18.4054938,36.1437977 18.2684142,36.2572972 18.2684142,36.4017268 C18.2684142,36.6236159 18.5590081,36.7782658 18.9867673,36.7782658 C19.4309041,36.7782658 19.7708592,36.6236159 19.7708592,36.375907 C19.7708592,36.154018 19.5405735,36.1023784 19.0689694,36.1023784 C18.9099387,36.1023784 18.6906571,36.092158 18.5864469,36.0816687 Z M11.9083323,33.4450892 C12.1686911,33.4450892 12.4711092,33.4988805 12.7011426,33.5824936 L12.8295609,33.6360483 L12.686965,34.1107563 C12.4402446,33.9921465 12.1167527,33.9146871 11.8918976,33.9146871 C11.6561527,33.9146871 11.5135567,33.9972567 11.5135567,34.1519066 C11.5135567,34.3326453 11.7274363,34.3945053 12.0235466,34.4614754 C12.5060691,34.5698648 12.8843813,34.7454934 12.8843813,35.2097121 C12.8843813,35.6534902 12.4786303,35.9837686 11.8315322,35.9837686 C11.5573587,35.9837686 11.2337025,35.9228799 10.9874462,35.8249162 L10.8499954,35.7618796 L10.9925914,35.2871715 C11.2449139,35.4213808 11.5683486,35.5090606 11.8479955,35.5090606 C12.1002323,35.5090606 12.2647507,35.4108915 12.2647507,35.2457523 C12.2647507,35.0601724 12.050871,34.9929333 11.7547608,34.9259631 C11.2776975,34.8226839 10.8993852,34.6371039 10.8993852,34.1882157 C10.8993852,33.7393275 11.2995342,33.4450892 11.9083323,33.4450892 Z M23.7842676,33.4450892 C24.5109915,33.4450892 24.8221402,33.7283469 24.847058,34.2987984 L24.8480636,34.4254353 L24.8480636,35.2769512 C24.8480636,35.4348622 24.8732292,35.4743694 25.0081169,35.4886257 L25.0728902,35.4934611 L25.0235289,35.9528386 C24.589233,35.9993143 24.363717,35.8911131 24.2550095,35.695879 L24.2228594,35.6276703 L24.200937,35.6276703 C24.0199553,35.8339599 23.8006165,35.9786584 23.4880716,35.9786584 C23.0329022,35.9786584 22.703894,35.6844201 22.703894,35.3078812 C22.703894,34.8950173 23.0050813,34.5417147 24.0051392,34.4713071 L24.200937,34.4614754 L24.200937,34.4047256 C24.200937,34.0849365 24.058341,33.9507272 23.6964063,33.9507272 C23.4902267,33.9507272 23.248962,34.0200965 23.0231436,34.1217921 L22.8574654,34.2035462 L22.7259879,33.723728 C23.0462373,33.54416 23.4114871,33.4479918 23.7842676,33.4450892 Z M16.2837039,33.4450892 C17.0104278,33.4450892 17.3215765,33.7283469 17.3464944,34.2987984 L17.3475,34.4254353 L17.3475,35.2769512 C17.3475,35.4348622 17.3726437,35.4743694 17.5075259,35.4886257 L17.5722979,35.4934611 L17.5229367,35.9528386 C17.0886665,35.9993143 16.8631299,35.8911131 16.7544181,35.695879 L16.7222672,35.6276703 L16.7003448,35.6276703 C16.5193631,35.8339599 16.3000243,35.9786584 15.9874794,35.9786584 C15.5323385,35.9786584 15.2033303,35.6844201 15.2033303,35.3078812 C15.2033303,34.8950173 15.5044924,34.5417147 16.5045472,34.4713071 L16.7003448,34.4614754 L16.7003448,34.4047256 C16.7003448,34.0849365 16.5577488,33.9507272 16.1958141,33.9507272 C15.9896573,33.9507272 15.7483972,34.0200965 15.5225797,34.1217921 L15.3569018,34.2035462 L15.2254243,33.723728 C15.5456704,33.5441528 15.9109223,33.4479841 16.2837039,33.4450892 Z M14.1563691,32.9806015 L14.1453936,33.5378792 L14.8583447,33.5378792 L14.8418815,34.038407 L14.1070936,34.038407 L14.0742243,35.1376318 C14.0685079,35.3595208 14.1892957,35.4625311 14.4086345,35.4625311 C14.4985263,35.4598391 14.5877257,35.4481262 14.6747323,35.4276664 L14.80341,35.3904508 L14.891157,35.8855995 C14.7028795,35.9487109 14.5042839,35.9802092 14.3044243,35.9786584 C13.7800107,35.9786584 13.4871837,35.7782914 13.465625,35.2912054 L13.4654834,35.1736719 L13.5038691,34.0540065 L13.1090364,34.0125872 L13.1254997,33.625559 L13.5203324,33.5069492 L13.5312507,32.9806015 L14.1563691,32.9806015 Z M9.56180158,33.4450892 C10.0325087,33.4450892 10.3256998,33.7088638 10.3680209,34.1511618 L10.3733323,34.2654062 L10.3733323,35.901199 L9.72631997,35.901199 L9.72631997,34.4512551 C9.72631997,34.100267 9.57826485,33.9816572 9.28761379,33.9816572 C9.10021069,33.9816572 8.92433967,34.0569277 8.79792819,34.1477004 L8.72831987,34.2035462 L8.72831987,35.901199 L8.081279,35.901199 L8.081279,33.532769 L8.72831987,33.4501994 L8.72831987,33.8270073 C8.95300351,33.594629 9.25471583,33.4450892 9.56180158,33.4450892 Z M22.0681144,33.4450892 C22.1862729,33.4430348 22.303221,33.4635898 22.4119991,33.5050766 L22.5177961,33.5534786 L22.3752002,34.100267 C22.2648473,34.0410062 22.1403123,34.0090789 22.0132654,34.007477 C21.8165922,34.007477 21.6324799,34.110231 21.4756723,34.3294325 L21.4101552,34.4305454 L21.4101552,35.901199 L20.7631143,35.901199 L20.7631143,33.5378792 L21.4101552,33.4501994 L21.4101552,33.8372276 C21.5691287,33.5844086 21.7720042,33.4450892 22.0681144,33.4450892 Z M28.554472,33.4450892 C28.9948117,33.4450892 29.2858617,33.7088638 29.3280331,34.1553926 L29.3333333,34.2707853 L29.3333333,35.901199 L28.6862353,35.901199 L28.6862353,34.4563653 C28.6862353,34.1056461 28.5381802,33.9816572 28.2695087,33.9816572 C28.0895789,33.9816572 27.9412768,34.0510265 27.8246025,34.1316531 L27.743027,34.1933259 L27.743027,35.901199 L27.0959862,35.901199 L27.0959862,34.4563653 C27.0959862,34.1056461 26.9533616,33.9816572 26.6846902,33.9816572 C26.5279071,33.9800059 26.3755842,34.0247349 26.2485405,34.1080894 L26.1583228,34.1777264 L26.1583228,35.901199 L25.5112819,35.901199 L25.5112819,33.532769 L26.1583228,33.4501994 L26.1583228,33.785588 C26.3941249,33.563699 26.6517922,33.4450892 26.9643371,33.4450892 C27.2714229,33.4450892 27.5291474,33.5844086 27.6552801,33.8528271 C27.9074882,33.594629 28.2092006,33.4450892 28.554472,33.4450892 Z M7.33017081,32.6761429 L7.33017081,35.901199 L6.66666667,35.901199 L6.66666667,32.6761429 L7.33017081,32.6761429 Z M16.7004591,34.7815335 C16.0698243,34.8536138 15.8395386,34.9724926 15.8395386,35.2253116 C15.8395386,35.4057813 15.9875937,35.5348804 16.2178794,35.5348804 C16.3657494,35.5342439 16.5077346,35.4860012 16.6211289,35.3998713 L16.7004591,35.3283219 L16.7004591,34.7815335 Z M24.2010513,34.7815335 C23.570388,34.8536138 23.3401308,34.9724926 23.3401308,35.2253116 C23.3401308,35.4057813 23.4881859,35.5348804 23.7184431,35.5348804 C23.8663198,35.5342445 24.0083121,35.4860023 24.1217147,35.3998719 L24.2010513,35.3283219 L24.2010513,34.7815335 Z M18.9647591,33.8579373 C18.679653,33.8579373 18.4986999,34.0591167 18.4986999,34.3584651 C18.4986999,34.6422141 18.679653,34.8331732 18.9922265,34.8331732 C19.282849,34.8331732 19.4473102,34.6371039 19.4473102,34.3377555 C19.4473102,34.0540065 19.2883082,33.8579373 18.9647591,33.8579373 Z M22.8261262,6.66666667 C26.4191563,6.66666667 29.3318826,9.47922808 29.3318826,12.9486984 L29.3318826,22.2704229 C29.3318826,25.7398933 26.4191563,28.5524547 22.8261262,28.5524547 L13.1724231,28.5524547 C9.57939304,28.5524547 6.66666667,25.7398933 6.66666667,22.2704229 L6.66666667,12.9486984 C6.66666667,9.47922808 9.57939304,6.66666667 13.1724231,6.66666667 L22.8261262,6.66666667 Z M22.8261262,8.69312852 L13.1724231,8.69312852 C10.738435,8.69312852 8.76529778,10.5984121 8.76529778,12.9486984 L8.76529778,22.2704229 C8.76529778,24.6207093 10.738435,26.5259928 13.1724231,26.5259928 L22.8261262,26.5259928 C25.2601143,26.5259928 27.2332515,24.6207093 27.2332515,22.2704229 L27.2332515,12.9486984 C27.2332515,10.5984121 25.2601143,8.69312852 22.8261262,8.69312852 Z M18.1702872,12.0215588 C21.466656,12.0215588 24.1363957,14.6146093 24.1363957,17.8103462 C24.1363957,21.0060831 21.466656,23.5991336 18.1702872,23.5991336 C14.8739184,23.5991336 12.2041788,21.0060831 12.2041788,17.8103462 C12.2041788,14.6146093 14.8739184,12.0215588 18.1702872,12.0215588 Z M18.1702872,14.0480207 C16.0357166,14.0480207 14.3028099,15.7311491 14.3028099,17.8103462 C14.3028099,19.8895433 16.0357166,21.5726717 18.1702872,21.5726717 C20.3048579,21.5726717 22.0377646,19.8895433 22.0377646,17.8103462 C22.0377646,15.7311491 20.3048579,14.0480207 18.1702872,14.0480207 Z M23.9271912,9.72660505 C24.7219629,9.72660505 25.3662526,10.3523873 25.3662526,11.1243289 C25.3662526,11.8962704 24.7219629,12.5220527 23.9271912,12.5220527 C23.1324196,12.5220527 22.4881299,11.8962704 22.4881299,11.1243289 C22.4881299,10.3523873 23.1324196,9.72660505 23.9271912,9.72660505 Z"
                        id="Combined-Shape"
                        fill="#000000"
                        fillRule="nonzero"
                      />
                      <rect
                        id="Frame"
                        stroke="#000000"
                        strokeWidth="1.33333333"
                        x={0}
                        y={0}
                        width={36}
                        height={48}
                        rx="2.66666667"
                      />
                    </g>
                  </g>
                </g>
              </svg>{" "}
            </a>
          </div>
        </div>
        <div className="footer__apps">
          <div className="apps-title footer-title"> our apps</div>
          <ul className="apps-links">
            <li className="apps-links__app-store">
              <a
                data-qaid="footer_appstore"
                href="https://apps.apple.com/us/app/promo-marketing-video-maker/id1304321154"
                target="_blank"
              >
                <svg
                  width="126px"
                  height="42px"
                  viewBox="0 0 126 42"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <title>CE741C20-7F4A-406F-ABC1-D2D01E501311</title>
                  <desc>Created with sketchtool.</desc>
                  <g
                    id="Footer-Design-25.12"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Assets"
                      transform="translate(-153.000000, -160.000000)"
                    >
                      <g id="Group" transform="translate(153.000000, 160.000000)">
                        <g fillRule="nonzero" id="Path">
                          <path
                            d="M11.2944586,-3.73034936e-14 C10.8600783,-3.73034936e-14 10.43091,-3.73034936e-14 9.99767861,0.0021 C9.6350237,0.0042 9.27525913,0.0103005 8.90912159,0.015435 C8.11370167,0.0237318938 7.3201523,0.0857600729 6.5353696,0.2009805 C5.7516892,0.318709259 4.99255816,0.540661527 4.2836516,0.8593305 C3.57561206,1.1806953 2.92865608,1.59827591 2.36625369,2.0969235 C1.80089879,2.59416884 1.32963183,3.1689172 0.970574229,3.799068 C0.610525651,4.42796458 0.360866805,5.10188521 0.23022042,5.797554 C0.0983319463,6.49234415 0.0273615585,7.19514657 0.0179461763,7.899654 C0.00695340297,8.221584 0.0057925282,8.544585 0,8.866557 L0,33.13653 C0.0057925282,33.462555 0.00695340297,33.778395 0.0179461763,34.104525 C0.0273644458,34.8089975 0.0983348348,35.5117648 0.23022042,36.20652 C0.360506051,36.9025955 0.610179659,37.576903 0.970574229,38.206035 C1.32946879,38.834148 1.80080203,39.4065695 2.36625369,39.90105 C2.92652363,40.4019148 3.57389778,40.8197795 4.2836516,41.138685 C4.99255278,41.4582069 5.75160197,41.6814802 6.5353696,41.801025 C7.32028571,41.9153225 8.11375347,41.9773759 8.90912159,41.986665 C9.27525913,41.993805 9.6350237,41.9979 9.99767861,41.9979 C10.4308981,42 10.860102,42 11.2944586,42 L114.711914,42 C115.137647,42 115.570251,42 115.995984,41.9979 C116.356921,41.9979 116.727098,41.993805 117.088035,41.986665 C117.8819,41.9778699 118.673874,41.9158125 119.457168,41.801025 C120.243464,41.6806387 121.005234,41.4574244 121.717557,41.138685 C122.42667,40.8195948 123.073447,40.4017415 123.633237,39.90105 C124.19723,39.4046329 124.669569,38.8326301 125.03292,38.206035 C125.39061,37.5764453 125.637907,36.9021917 125.766285,36.20652 C125.898382,35.5116695 125.971871,34.8090585 125.986141,34.104525 C125.99076,33.778395 125.99076,33.462555 125.99076,33.13653 C126,32.755065 126,32.3757 126,31.98804 L126,10.0129365 C126,9.628416 126,9.246972 125.99076,8.866557 C125.99076,8.544585 125.99076,8.221584 125.986141,7.899612 C125.971873,7.19504357 125.898385,6.49239745 125.766285,5.797512 C125.63755,5.10224568 125.390267,4.42837844 125.03292,3.799026 C124.301716,2.53595588 123.142238,1.50782667 121.717557,0.859236 C121.005232,0.541345749 120.24338,0.31945243 119.457168,0.200886 C118.674009,0.0851579223 117.881953,0.0231081531 117.088035,0.015288 C116.727098,0.010164 116.356921,0.004011 115.995984,0.0019635 C115.570251,-3.73034936e-14 115.137647,-3.73034936e-14 114.711914,-3.73034936e-14 L11.2944586,-3.73034936e-14 Z"
                            fill="#A6A6A6"
                          />
                          <path
                            d="M10.0172834,41.08125 C9.65645181,41.08125 9.30433664,41.077155 8.94633551,41.070015 C8.20470717,41.0614478 7.46481219,41.0042063 6.73271869,40.89876 C6.05007844,40.7945246 5.38878353,40.6006277 4.77064654,40.323465 C4.15817755,40.0485988 3.59955659,39.6881865 3.11618369,39.256035 C2.62581408,38.828974 2.21755898,38.3336562 1.9075968,37.78971 C1.59421911,37.2422286 1.37734309,36.6553945 1.26452355,36.04965 C1.14268824,35.3987706 1.07677029,34.7406289 1.06733811,34.0809 C1.05982966,33.859455 1.05,33.122145 1.05,33.122145 L1.05,8.866557 C1.05,8.866557 1.06046919,8.1405765 1.06739732,7.92729 C1.07642857,7.26860615 1.1419632,6.61148575 1.263434,5.9616165 C1.37646179,5.35421258 1.5935057,4.76568631 1.90705202,4.2164115 C2.21587501,3.67284104 2.62186357,3.17715331 3.10927924,2.748564 C3.59614707,2.31590249 4.15655495,1.95363432 4.77006624,1.6749705 C5.38678256,1.39869828 6.04682771,1.20616917 6.72808809,1.1038335 C7.46258591,0.997327945 8.20504951,0.939745889 8.94924888,0.9315705 L10.0178637,0.91875 L115.976345,0.91875 L117.057727,0.932085 C117.795157,0.939854158 118.530876,0.996922506 119.258624,1.1028045 C119.946781,1.20642382 120.613705,1.40029631 121.237466,1.678047 C122.466551,2.23963535 123.466634,3.1281211 124.097543,4.2189735 C124.406085,4.76445644 124.619781,5.34818209 124.731379,5.9503395 C124.854296,6.60554095 124.923089,7.26782525 124.93721,7.93191 C124.940644,8.22927 124.940644,8.54868 124.940644,8.866557 C124.95,9.260307 124.95,9.6350835 124.95,10.0129365 L124.95,31.98804 C124.95,32.369505 124.95,32.74173 124.940644,33.117 C124.940644,33.45846 124.940644,33.771255 124.936025,34.093185 C124.92221,34.7454195 124.854564,35.3958825 124.733629,36.03936 C124.623122,36.6494742 124.407427,37.2408888 124.094109,37.79286 C123.781955,38.3309022 123.376045,38.8219295 122.891337,39.247845 C122.407529,39.6823189 121.847922,40.0448398 121.234031,40.32147 C120.611998,40.6007634 119.946056,40.7953773 119.258624,40.89876 C118.526586,41.004769 117.78662,41.0620142 117.044936,41.070015 C116.698056,41.077155 116.334832,41.08125 115.982148,41.08125 L114.69837,41.08335 L10.0172834,41.08125 Z"
                            fill="#000000"
                          />
                        </g>
                        <g
                          id="_Group_"
                          transform="translate(10.500000, 6.562500)"
                        >
                          <g
                            id="_Group_2"
                            transform="translate(0.000000, 1.312500)"
                            fill="#FFFFFF"
                            fillRule="nonzero"
                          >
                            <g id="_Group_3">
                              <g id="Group-10">
                                <path
                                  d="M16.1086905,12.456864 C16.1316403,10.6755696 17.0654956,9.03019542 18.5830785,8.097201 C17.6213548,6.72368841 16.0682781,5.88407227 14.3923605,5.831637 C12.6291585,5.646564 10.919811,6.8867085 10.0213155,6.8867085 C9.105432,6.8867085 7.722057,5.850012 6.2323905,5.8806615 C4.27237783,5.94398534 2.48941053,7.03135175 1.5358245,8.744925 C-0.4948755,12.260766 1.019844,17.4278685 2.9650845,20.269809 C3.9383295,21.6614265 5.0757735,23.215899 6.564096,23.160774 C8.020509,23.1003675 8.564451,22.23207 10.322466,22.23207 C12.064164,22.23207 12.5744955,23.160774 14.093016,23.125725 C15.655815,23.100357 16.6404525,21.727923 17.5795515,20.323128 C18.2788264,19.3315497 18.8169174,18.2356397 19.1738925,17.0759925 C17.3177619,16.2909403 16.1108569,14.4721861 16.1086905,12.456864 L16.1086905,12.456864 Z"
                                  id="_Path_"
                                />
                                <path
                                  d="M13.240479,3.9625845 C14.0925819,2.939666 14.5123807,1.62487758 14.410725,0.2974335 C13.1089012,0.434165012 11.9063807,1.05635216 11.042766,2.040024 C10.1899862,3.01054848 9.75796986,4.28025431 9.8418705,5.5694835 C11.1611502,5.5830671 12.4137784,4.99081088 13.240479,3.9625845 L13.240479,3.9625845 Z"
                                  id="_Path_2"
                                />
                                <path
                                  d="M34.51875,19.6377825 L29.54868,19.6377825 L28.355124,23.162055 L26.25,23.162055 L30.95757,10.123155 L33.14472,10.123155 L37.85229,23.162055 L35.7112665,23.162055 L34.51875,19.6377825 Z M30.0634215,18.011511 L34.0030215,18.011511 L32.060931,12.2918775 L32.006583,12.2918775 L30.0634215,18.011511 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M48.019041,18.4093665 C48.019041,21.3635205 46.437888,23.261511 44.051805,23.261511 C42.8184595,23.3260279 41.6567155,22.6800322 41.0607435,21.598311 L41.0155935,21.598311 L41.0155935,26.30691 L39.0642735,26.30691 L39.0642735,13.655649 L40.9530765,13.655649 L40.9530765,15.236802 L40.9889655,15.236802 C41.6114142,14.1618623 42.774411,13.5161448 44.015916,13.5561825 C46.4286165,13.556193 48.019041,15.463413 48.019041,18.4093665 Z M46.013373,18.4093665 C46.013373,16.4847165 45.0187395,15.219372 43.501164,15.219372 C42.010248,15.219372 41.007414,16.5113655 41.007414,18.4093665 C41.007414,20.3247975 42.010248,21.6075615 43.501164,21.6075615 C45.01875,21.6075615 46.013373,20.351457 46.013373,18.4093665 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M58.482123,18.4093665 C58.482123,21.3635205 56.90097,23.261511 54.514887,23.261511 C53.2815415,23.3260279 52.1197975,22.6800322 51.5238255,21.598311 L51.4786755,21.598311 L51.4786755,26.30691 L49.5273555,26.30691 L49.5273555,13.655649 L51.4161165,13.655649 L51.4161165,15.236802 L51.4520055,15.236802 C52.0744588,14.161863 53.23746,13.5161492 54.4789665,13.556193 C56.8917405,13.556193 58.482123,15.463413 58.482123,18.4093665 Z M56.4764655,18.4093665 C56.4764655,16.4847165 55.4818215,15.219372 53.964246,15.219372 C52.47333,15.219372 51.470496,16.5113655 51.470496,18.4093665 C51.470496,20.3247975 52.47333,21.6075615 53.964246,21.6075615 C55.481832,21.6075615 56.4764655,20.351457 56.4764655,18.4093665 L56.4764655,18.4093665 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M65.39736,19.5290865 C65.541945,20.822109 66.79806,21.6710865 68.5145475,21.6710865 C70.159278,21.6710865 71.3425755,20.822067 71.3425755,19.656189 C71.3425755,18.6441255 70.628901,18.038139 68.9390625,17.622843 L67.249224,17.215758 C64.8549405,16.637439 63.7434105,15.5177085 63.7434105,13.700715 C63.7434105,11.451006 65.70396,9.905742 68.487888,9.905742 C71.243088,9.905742 73.1318805,11.451006 73.195458,13.700715 L71.225658,13.700715 C71.107743,12.399492 70.032102,11.61405 68.4601785,11.61405 C66.888255,11.61405 65.8126245,12.408732 65.8126245,13.56537 C65.8126245,14.4871965 66.4996395,15.0296265 68.1802485,15.44487 L69.6168165,15.797607 C72.292059,16.430274 73.403589,17.504907 73.403589,19.412106 C73.403589,21.851508 71.4604695,23.379342 68.3699415,23.379342 C65.478336,23.379342 63.5259975,21.887397 63.3998715,19.528992 L65.39736,19.5290865 Z"
                                  id="Path"
                                />
                                <path
                                  d="M77.614887,11.40594 L77.614887,13.655649 L79.422651,13.655649 L79.422651,15.200913 L77.614887,15.200913 L77.614887,20.4416835 C77.614887,21.255843 77.9768535,21.6352395 78.771525,21.6352395 C78.986136,21.6314972 79.2003998,21.6164263 79.4134215,21.5900895 L79.4134215,23.126124 C79.0561362,23.1928825 78.6929859,23.2231172 78.32958,23.216361 C76.40493,23.216361 75.6543375,22.493457 75.6543375,20.649804 L75.6543375,15.200913 L74.2721175,15.200913 L74.2721175,13.655649 L75.6543165,13.655649 L75.6543165,11.40594 L77.614887,11.40594 Z"
                                  id="Path"
                                />
                                <path
                                  d="M80.4696165,18.4093665 C80.4696165,15.418305 82.231233,13.538763 84.978264,13.538763 C87.734514,13.538763 89.48793,15.418263 89.48793,18.4093665 C89.48793,21.408639 87.7437435,23.27997 84.978264,23.27997 C82.213761,23.27997 80.4696165,21.4086285 80.4696165,18.4093665 Z M87.499692,18.4093665 C87.499692,16.3575615 86.5594065,15.1465755 84.9782535,15.1465755 C83.3971005,15.1465755 82.457844,16.366791 82.457844,18.4093665 C82.457844,20.469372 83.3971005,21.671139 84.9782535,21.671139 C86.5594065,21.671139 87.499692,20.469372 87.499692,18.4093665 L87.499692,18.4093665 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M91.096719,13.655649 L92.9578125,13.655649 L92.9578125,15.273699 L93.0029625,15.273699 C93.2624973,14.2320868 94.2169017,13.5152131 95.289579,13.556172 C95.5144512,13.5553868 95.738703,13.5798083 95.958135,13.628979 L95.958135,15.454173 C95.6742475,15.3674255 95.3781041,15.3275969 95.081385,15.336258 C94.5077156,15.3129852 93.9525309,15.5416115 93.561606,15.9621063 C93.1706811,16.3826011 92.9830719,16.9529543 93.048039,17.523408 L93.048039,23.162034 L91.096719,23.162034 L91.096719,13.655649 Z"
                                  id="Path"
                                />
                                <path
                                  d="M104.954881,20.3699055 C104.692381,22.095633 103.011762,23.2799595 100.861519,23.2799595 C98.09604,23.2799595 96.379542,21.427077 96.379542,18.4544745 C96.379542,15.4726425 98.1052695,13.5387525 100.779493,13.5387525 C103.409617,13.5387525 105.063577,15.3454875 105.063577,18.2278635 L105.063577,18.8964195 L98.349321,18.8964195 L98.349321,19.0143345 C98.2866333,19.7220677 98.5310147,20.4226254 99.0203024,20.9378084 C99.5095902,21.4529914 100.196625,21.733145 100.906648,21.707007 C101.853583,21.7957316 102.746357,21.2519766 103.102009,20.369895 L104.954881,20.3699055 Z M98.358532,17.5326585 L103.111228,17.5326585 C103.14664,16.8967024 102.915148,16.2748142 102.472524,15.8168131 C102.0299,15.358812 101.416277,15.1062244 100.779493,15.1199055 C100.137672,15.1160753 99.5209118,15.3687814 99.0662983,15.8218549 C98.6116848,16.2749285 98.3568876,16.8908281 98.358532,17.5326585 L98.358532,17.5326585 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M29.818866,0.3087 C30.6472599,0.24925339 31.4586534,0.5644248 32.0297159,1.16746541 C32.6007783,1.77050602 32.8713167,2.59785203 32.766867,3.421782 C32.766867,5.4233445 31.6850835,6.573882 29.818866,6.573882 L27.5558325,6.573882 L27.5558325,0.3087 L29.818866,0.3087 Z M28.52892,5.68785 L29.71017,5.68785 C30.302183,5.72323711 30.8786274,5.48998696 31.2794459,5.05286438 C31.6802645,4.6157418 31.8627851,4.02128414 31.7763285,3.43455 C31.856495,2.85025076 31.6713459,2.26069853 31.2715211,1.82714068 C30.8716963,1.39358283 30.299037,1.16139061 29.71017,1.1940705 L28.52892,1.1940705 L28.52892,5.68785 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M33.8660805,4.207707 C33.785007,3.3602363 34.1913743,2.54006753 34.9147532,2.09117724 C35.6381321,1.64228694 36.5534524,1.64228694 37.2768313,2.09117724 C38.0002102,2.54006753 38.4065775,3.3602363 38.325504,4.207707 C38.40812,5.05608838 38.0021236,5.8778479 37.2781033,6.32770457 C36.5540831,6.77756123 35.6375014,6.77756123 34.9134812,6.32770457 C34.1894609,5.8778479 33.7834645,5.05608838 33.8660805,4.207707 Z M37.365741,4.207707 C37.365741,3.1828335 36.9053265,2.5834935 36.0973305,2.5834935 C35.2862475,2.5834935 34.8299805,3.1828335 34.8299805,4.2077175 C34.8299805,5.240802 35.286279,5.835522 36.0973305,5.835522 C36.9053475,5.835522 37.365741,5.236686 37.365741,4.207707 L37.365741,4.207707 Z"
                                  id="Shape"
                                />
                                <polygon
                                  id="Path"
                                  points="44.2532895 6.5737875 43.285326 6.5737875 42.308133 3.091557 42.2343075 3.091557 41.2612095 6.5737875 40.302465 6.5737875 38.9991945 1.845711 39.945633 1.845711 40.792605 5.453511 40.8623355 5.453511 41.8344045 1.845711 42.7295715 1.845711 43.7016405 5.453511 43.775466 5.453511 44.6183325 1.845711 45.551436 1.845711"
                                />
                                <path
                                  d="M46.647573,1.845711 L47.5458165,1.845711 L47.5458165,2.5968075 L47.615547,2.5968075 C47.8580286,2.04380184 48.424638,1.70552285 49.0264845,1.754445 C49.4924921,1.71940836 49.9491467,1.8981794 50.2675118,2.24028217 C50.585877,2.58238495 50.7314042,3.05069495 50.663004,3.512985 L50.663004,6.573735 L49.7299005,6.573735 L49.7299005,3.747303 C49.7299005,2.9874915 49.399728,2.609628 48.7096365,2.609628 C48.3935506,2.59490607 48.0867977,2.7189567 47.8697988,2.94925762 C47.6528,3.17955855 47.5471973,3.49314106 47.5806765,3.8077935 L47.5806765,6.5737875 L46.647573,6.5737875 L46.647573,1.845711 Z"
                                  id="Path"
                                />
                                <polygon
                                  id="Path"
                                  points="52.149825 0 53.0829285 0 53.0829285 6.573777 52.149825 6.573777"
                                />
                                <path
                                  d="M54.380046,4.207707 C54.2990348,3.36018086 54.7054662,2.53999133 55.4288988,2.09109411 C56.1523313,1.64219689 57.0676987,1.64219689 57.7911312,2.09109411 C58.5145638,2.53999133 58.9209952,3.36018086 58.839984,4.207707 C58.9224951,5.05611875 58.5164243,5.87785505 57.7923681,6.3276919 C57.0683119,6.77752875 56.1517181,6.77752875 55.4276619,6.3276919 C54.7036057,5.87785505 54.2975349,5.05611875 54.380046,4.207707 L54.380046,4.207707 Z M57.8797065,4.207707 C57.8797065,3.1828335 57.419292,2.5834935 56.611296,2.5834935 C55.800213,2.5834935 55.343946,3.1828335 55.343946,4.2077175 C55.343946,5.240802 55.8002445,5.835522 56.611296,5.835522 C57.4193025,5.835522 57.8797065,5.236686 57.8797065,4.207707 L57.8797065,4.207707 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M59.8223115,5.236686 C59.8223115,4.3856085 60.4560075,3.8949645 61.5808515,3.825234 L62.861568,3.7514085 L62.861568,3.343305 C62.861568,2.8439355 62.5313955,2.561958 61.8936045,2.561958 C61.37271,2.561958 61.0117725,2.7531945 60.9082005,3.0874725 L60.004833,3.0874725 C60.100194,2.2753605 60.864111,1.754466 61.936665,1.754466 C63.1220205,1.754466 63.7905765,2.344566 63.7905765,3.343305 L63.7905765,6.573798 L62.892333,6.573798 L62.892333,5.9093475 L62.8185075,5.9093475 C62.5134285,6.39458015 61.9708988,6.67817139 61.3983405,6.6516975 C60.9969634,6.69344741 60.5966562,6.56345619 60.2963821,6.29386007 C59.996108,6.02426394 59.8238929,5.64022548 59.8223115,5.236686 L59.8223115,5.236686 Z M62.861568,4.8326775 L62.861568,4.4373945 L61.7069775,4.51122 C61.0558515,4.554795 60.760539,4.776282 60.760539,5.1931005 C60.760539,5.618634 61.129677,5.866266 61.637289,5.866266 C61.9377844,5.89668436 62.2377592,5.8038488 62.4685429,5.60901137 C62.6993266,5.41417393 62.8411577,5.13401811 62.861568,4.8326775 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M65.0169345,4.207707 C65.0169345,2.7137145 65.784957,1.767276 66.9795315,1.767276 C67.5827321,1.73948264 68.1476854,2.06269651 68.4294345,2.596776 L68.499165,2.596776 L68.499165,-3.73034936e-14 L69.4322685,-3.73034936e-14 L69.4322685,6.573777 L68.5381305,6.573777 L68.5381305,5.8267755 L68.464305,5.8267755 C68.1612584,6.35642383 67.5893448,6.6741743 66.979542,6.6516975 C65.7767565,6.65175 65.0169345,5.7052905 65.0169345,4.207707 Z M65.9808345,4.207707 C65.9808345,5.210541 66.4535445,5.8139865 67.244121,5.8139865 C68.030571,5.8139865 68.5166265,5.2018365 68.5166265,4.2118125 C68.5166265,3.2264085 68.025468,2.605533 67.244121,2.605533 C66.458637,2.605533 65.980803,3.2130735 65.980803,4.207707 L65.9808345,4.207707 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M73.2928665,4.207707 C73.211793,3.3602363 73.6181603,2.54006753 74.3415392,2.09117724 C75.0649181,1.64228694 75.9802384,1.64228694 76.7036173,2.09117724 C77.4269962,2.54006753 77.8333635,3.3602363 77.75229,4.207707 C77.834906,5.05608838 77.4289096,5.8778479 76.7048893,6.32770457 C75.9808691,6.77756123 75.0642874,6.77756123 74.3402672,6.32770457 C73.6162469,5.8778479 73.2102505,5.05608838 73.2928665,4.207707 L73.2928665,4.207707 Z M76.7925165,4.207707 C76.7925165,3.1828335 76.3321125,2.5834935 75.5241165,2.5834935 C74.7130335,2.5834935 74.2567665,3.1828335 74.2567665,4.2077175 C74.2567665,5.240802 74.713065,5.835522 75.5241165,5.835522 C76.332123,5.835522 76.7925165,5.236686 76.7925165,4.207707 Z"
                                  id="Shape"
                                />
                                <path
                                  d="M79.004289,1.845711 L79.9025325,1.845711 L79.9025325,2.5968075 L79.972263,2.5968075 C80.2147446,2.04380184 80.781354,1.70552285 81.3832005,1.754445 C81.8492081,1.71940836 82.3058627,1.8981794 82.6242278,2.24028217 C82.942593,2.58238495 83.0881202,3.05069495 83.01972,3.512985 L83.01972,6.573735 L82.0866165,6.573735 L82.0866165,3.747303 C82.0866165,2.9874915 81.756444,2.609628 81.0663525,2.609628 C80.7502666,2.59490607 80.4435137,2.7189567 80.2265148,2.94925762 C80.009516,3.17955855 79.9039133,3.49314106 79.9373925,3.8077935 L79.9373925,6.5737875 L79.004289,6.5737875 L79.004289,1.845711 Z"
                                  id="Path"
                                />
                                <path
                                  d="M88.2922845,0.6685665 L88.2922845,1.8672465 L89.316654,1.8672465 L89.316654,2.6532135 L88.2922845,2.6532135 L88.2922845,5.084415 C88.2922845,5.579679 88.4963415,5.796546 88.9608405,5.796546 C89.0797588,5.79616542 89.1985578,5.78897514 89.316654,5.7750105 L89.316654,6.552252 C89.149084,6.58223025 88.9793054,6.59817904 88.809084,6.5999325 C87.77139,6.5999325 87.358152,6.2348895 87.358152,5.3233215 L87.358152,2.6531715 L86.60757,2.6531715 L86.60757,1.8672045 L87.358152,1.8672045 L87.358152,0.6685665 L88.2922845,0.6685665 Z"
                                  id="Path"
                                />
                                <path
                                  d="M90.591207,0 L91.51611,0 L91.51611,2.6055225 L91.5899355,2.6055225 C91.8440647,2.04767699 92.4205906,1.70896692 93.0315855,1.7585505 C93.4949469,1.73333715 93.9454197,1.9160439 94.2603052,2.25690555 C94.5751907,2.59776719 94.7216917,3.06128092 94.6599045,3.521196 L94.6599045,6.5737875 L93.7258665,6.5737875 L93.7258665,3.7513875 C93.7258665,2.9961855 93.3741165,2.6137125 92.714832,2.6137125 C92.3902024,2.58708835 92.0703725,2.70510551 91.8408459,2.93621318 C91.6113193,3.16732085 91.4955005,3.48795333 91.5243525,3.8123925 L91.5243525,6.5737875 L90.591249,6.5737875 L90.591207,0 Z"
                                  id="Path"
                                />
                                <path
                                  d="M100.100679,5.2971765 C99.8390264,6.18902496 98.9759703,6.76525819 98.0519505,6.665043 C97.4214926,6.68168571 96.8155875,6.42036223 96.3949962,5.95040792 C95.9744048,5.48045361 95.7816472,4.84937874 95.8678665,4.2246225 C95.7839373,3.59813 95.9759726,2.96604392 96.3942219,2.4921193 C96.8124711,2.01819469 97.4157786,1.74906559 98.047845,1.7544555 C99.3634215,1.7544555 100.157075,2.6532555 100.157075,4.1379555 L100.157075,4.46355 L96.8184,4.46355 L96.8184,4.51584 C96.7888551,4.86668715 96.9086798,5.21372014 97.1484053,5.47159273 C97.3881309,5.72946533 97.7255138,5.87425012 98.077581,5.87034 C98.5340914,5.92514442 98.9784731,5.6986997 99.2024355,5.297145 L100.100679,5.2971765 Z M96.818379,3.773448 L99.2065095,3.773448 C99.230295,3.45256846 99.1174679,3.13656533 98.8958323,2.90331205 C98.6741967,2.67005877 98.3643649,2.54124804 98.0426895,2.548623 C97.7166561,2.54452686 97.4027859,2.6722723 97.1722777,2.90288133 C96.9417695,3.13349035 96.8141613,3.44741642 96.8184,3.773448 L96.818379,3.773448 Z"
                                  id="Shape"
                                />
                              </g>
                            </g>
                          </g>
                          <g
                            id="Group"
                            transform="translate(17.850000, 0.262500)"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
            <li className="apps-links__google-play">
              <a
                data-qaid="footer_google_play"
                href="https://play.google.com/store/apps/details?id=com.promo.mobile"
                target="_blank"
              >
                <svg
                  width="142px"
                  height="42px"
                  viewBox="0 0 142 42"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <title>C9A0BFA2-2DB3-4EF3-B9BE-F823BEBEC79C</title>
                  <desc>Created with sketchtool.</desc>
                  <defs>
                    <linearGradient
                      x1="61.0265807%"
                      y1="4.96288907%"
                      x2="26.4999303%"
                      y2="71.9317638%"
                      id="linearGradient-1"
                    >
                      <stop stopColor="#00A0FF" offset="0%" />
                      <stop stopColor="#00A1FF" offset="0.657445%" />
                      <stop stopColor="#00BEFF" offset="26.01%" />
                      <stop stopColor="#00D2FF" offset="51.22%" />
                      <stop stopColor="#00DFFF" offset="76.04%" />
                      <stop stopColor="#00E3FF" offset="100%" />
                    </linearGradient>
                    <linearGradient
                      x1="107.621063%"
                      y1="50.0630841%"
                      x2="-130.537402%"
                      y2="50.0630841%"
                      id="linearGradient-2"
                    >
                      <stop stopColor="#FFE000" offset="0%" />
                      <stop stopColor="#FFBD00" offset="40.87%" />
                      <stop stopColor="#FFA500" offset="77.54%" />
                      <stop stopColor="#FF9C00" offset="100%" />
                    </linearGradient>
                    <linearGradient
                      x1="86.2523981%"
                      y1="30.8770741%"
                      x2="-50.1882494%"
                      y2="136.143112%"
                      id="linearGradient-3"
                    >
                      <stop stopColor="#FF3A44" offset="0%" />
                      <stop stopColor="#C31162" offset="100%" />
                    </linearGradient>
                    <linearGradient
                      x1="-18.7699221%"
                      y1="-11.8133983%"
                      x2="42.1198322%"
                      y2="35.0993451%"
                      id="linearGradient-4"
                    >
                      <stop stopColor="#32A071" offset="0%" />
                      <stop stopColor="#2DA771" offset="6.85%" />
                      <stop stopColor="#15CF74" offset="47.62%" />
                      <stop stopColor="#06E775" offset="80.09%" />
                      <stop stopColor="#00F076" offset="100%" />
                    </linearGradient>
                  </defs>
                  <g
                    id="Footer-Design-25.12"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Assets"
                      transform="translate(-295.000000, -160.000000)"
                      fillRule="nonzero"
                    >
                      <g
                        id="google-play-badge"
                        transform="translate(295.000000, 160.000000)"
                      >
                        <path
                          d="M136.5,42 L5.25,42 C2.3625,42 0,39.6375 0,36.75 L0,5.25 C0,2.3625 2.3625,0 5.25,0 L136.5,0 C139.3875,0 141.75,2.3625 141.75,5.25 L141.75,36.75 C141.75,39.6375 139.3875,42 136.5,42 Z"
                          id="Path"
                          fill="#000000"
                        />
                        <path
                          d="M136.5,0.84 C138.936,0.84 140.91,2.814 140.91,5.25 L140.91,36.75 C140.91,39.186 138.936,41.16 136.5,41.16 L5.25,41.16 C2.814,41.16 0.84,39.186 0.84,36.75 L0.84,5.25 C0.84,2.814 2.814,0.84 5.25,0.84 L136.5,0.84 M136.5,0 L5.25,0 C2.3625,0 0,2.3625 0,5.25 L0,36.75 C0,39.6375 2.3625,42 5.25,42 L136.5,42 C139.3875,42 141.75,39.6375 141.75,36.75 L141.75,5.25 C141.75,2.3625 139.3875,0 136.5,0 L136.5,0 Z"
                          id="Shape"
                          fill="#A6A6A6"
                        />
                        <g
                          id="Group"
                          transform="translate(43.050000, 6.300000)"
                          fill="#FFFFFF"
                          stroke="#FFFFFF"
                          strokeWidth="0.65625"
                        >
                          <path
                            d="M6.741,4.4625 C6.741,5.3445 6.4785,6.048 5.9535,6.5625 C5.3655,7.182 4.5885,7.497 3.6435,7.497 C2.73,7.497 1.9635,7.182 1.323,6.552 C0.6825,5.922 0.3675,5.1345 0.3675,4.2105 C0.3675,3.276 0.6825,2.499 1.323,1.869 C1.9635,1.239 2.73,0.924 3.6435,0.924 C4.095,0.924 4.5255,1.008 4.935,1.1865 C5.3445,1.365 5.67,1.596 5.922,1.89 L5.3655,2.4465 C4.9455,1.953 4.3785,1.701 3.6435,1.701 C2.982,1.701 2.4045,1.932 1.9215,2.4045 C1.4385,2.8665 1.197,3.4755 1.197,4.221 C1.197,4.9665 1.4385,5.5755 1.9215,6.0375 C2.4045,6.4995 2.982,6.741 3.6435,6.741 C4.347,6.741 4.935,6.51 5.4075,6.0375 C5.712,5.733 5.8905,5.3025 5.9325,4.7565 L3.6435,4.7565 L3.6435,3.9795 L6.699,3.9795 C6.72,4.1475 6.741,4.305 6.741,4.4625 Z"
                            id="Path"
                          />
                          <polygon
                            id="Path"
                            points="11.5815 1.827 8.715 1.827 8.715 3.822 11.298 3.822 11.298 4.578 8.715 4.578 8.715 6.573 11.5815 6.573 11.5815 7.35 7.9065 7.35 7.9065 1.05 11.5815 1.05 11.5815 1.827"
                          />
                          <polygon
                            id="Path"
                            points="14.994 7.35 14.1855 7.35 14.1855 1.827 12.4215 1.827 12.4215 1.05 16.7475 1.05 16.7475 1.827 14.9835 1.827 14.9835 7.35"
                          />
                          <polygon
                            id="Path"
                            points="19.887 7.35 19.887 1.05 20.6955 1.05 20.6955 7.35"
                          />
                          <polygon
                            id="Path"
                            points="24.2865 7.35 23.478 7.35 23.478 1.827 21.714 1.827 21.714 1.05 26.04 1.05 26.04 1.827 24.276 1.827 24.276 7.35"
                          />
                          <path
                            d="M34.2405,6.5415 C33.621,7.182 32.8545,7.497 31.9305,7.497 C31.0065,7.497 30.24,7.182 29.6205,6.5415 C29.001,5.901 28.6965,5.124 28.6965,4.2105 C28.6965,3.297 29.001,2.5095 29.6205,1.8795 C30.24,1.239 31.0065,0.924 31.9305,0.924 C32.844,0.924 33.6105,1.239 34.2405,1.8795 C34.86,2.52 35.175,3.297 35.175,4.2105 C35.1645,5.124 34.86,5.901 34.2405,6.5415 Z M30.219,6.0165 C30.681,6.489 31.2585,6.72 31.9305,6.72 C32.6025,6.72 33.18,6.489 33.642,6.0165 C34.104,5.544 34.3455,4.9455 34.3455,4.2105 C34.3455,3.4755 34.1145,2.877 33.642,2.4045 C33.18,1.932 32.6025,1.701 31.9305,1.701 C31.2585,1.701 30.681,1.932 30.219,2.4045 C29.757,2.877 29.5155,3.4755 29.5155,4.2105 C29.5155,4.9455 29.757,5.544 30.219,6.0165 Z"
                            id="Shape"
                          />
                          <polygon
                            id="Path"
                            points="36.309 7.35 36.309 1.05 37.296 1.05 40.362 5.9535 40.3935 5.9535 40.362 4.7355 40.362 1.05 41.1705 1.05 41.1705 7.35 40.3305 7.35 37.128 2.2155 37.0965 2.2155 37.128 3.4335 37.128 7.35"
                          />
                        </g>
                        <path
                          d="M71.547,22.848 C69.0795,22.848 67.0635,24.7275 67.0635,27.3105 C67.0635,29.883 69.0795,31.773 71.547,31.773 C74.0145,31.773 76.0305,29.883 76.0305,27.3105 C76.0305,24.717 74.0145,22.848 71.547,22.848 Z M71.547,30.0195 C70.1925,30.0195 69.027,28.9065 69.027,27.3105 C69.027,25.704 70.1925,24.6015 71.547,24.6015 C72.9015,24.6015 74.067,25.704 74.067,27.3105 C74.067,28.896 72.891,30.0195 71.547,30.0195 Z M61.761,22.848 C59.2935,22.848 57.2775,24.7275 57.2775,27.3105 C57.2775,29.883 59.2935,31.773 61.761,31.773 C64.2285,31.773 66.2445,29.883 66.2445,27.3105 C66.2445,24.717 64.2285,22.848 61.761,22.848 Z M61.761,30.0195 C60.4065,30.0195 59.241,28.9065 59.241,27.3105 C59.241,25.704 60.4065,24.6015 61.761,24.6015 C63.1155,24.6015 64.281,25.704 64.281,27.3105 C64.281,28.896 63.1155,30.0195 61.761,30.0195 Z M50.127,24.213 L50.127,26.103 L54.663,26.103 C54.5265,27.1635 54.1695,27.951 53.634,28.4865 C52.9725,29.148 51.9435,29.8725 50.1375,29.8725 C47.3445,29.8725 45.1605,27.6255 45.1605,24.8325 C45.1605,22.0395 47.3445,19.7925 50.1375,19.7925 C51.639,19.7925 52.7415,20.3805 53.55,21.147 L54.8835,19.8135 C53.7495,18.732 52.248,17.9025 50.127,17.9025 C46.305,17.9025 43.092,21.0105 43.092,24.843 C43.092,28.665 46.305,31.7835 50.127,31.7835 C52.1955,31.7835 53.7495,31.1115 54.9675,29.841 C56.217,28.5915 56.6055,26.8275 56.6055,25.41 C56.6055,24.969 56.574,24.5595 56.5005,24.2235 L50.127,24.2235 L50.127,24.213 Z M97.7025,25.683 C97.335,24.6855 96.201,22.8375 93.8805,22.8375 C91.581,22.8375 89.67,24.6435 89.67,27.3 C89.67,29.799 91.56,31.7625 94.101,31.7625 C96.1485,31.7625 97.335,30.513 97.818,29.7885 L96.2955,28.77 C95.7915,29.5155 95.0985,30.009 94.101,30.009 C93.1035,30.009 92.3895,29.5575 91.938,28.6545 L97.9125,26.187 L97.7025,25.683 Z M91.6125,27.174 C91.56,25.452 92.946,24.57 93.9435,24.57 C94.7205,24.57 95.382,24.9585 95.6025,25.515 L91.6125,27.174 Z M86.7615,31.5 L88.725,31.5 L88.725,18.375 L86.7615,18.375 L86.7615,31.5 Z M83.5485,23.8455 L83.475,23.8455 C83.034,23.3205 82.194,22.848 81.123,22.848 C78.8865,22.848 76.839,24.8115 76.839,27.3315 C76.839,29.8305 78.8865,31.7835 81.123,31.7835 C82.194,31.7835 83.034,31.311 83.475,30.765 L83.538,30.765 L83.538,31.4055 C83.538,33.117 82.6245,34.0305 81.1545,34.0305 C79.9575,34.0305 79.212,33.1695 78.9075,32.445 L77.196,33.159 C77.6895,34.3455 78.9915,35.7945 81.1545,35.7945 C83.454,35.7945 85.3965,34.44 85.3965,31.143 L85.3965,23.121 L83.538,23.121 L83.538,23.8455 L83.5485,23.8455 Z M81.291,30.0195 C79.9365,30.0195 78.8025,28.8855 78.8025,27.3315 C78.8025,25.7565 79.9365,24.612 81.291,24.612 C82.6245,24.612 83.6745,25.767 83.6745,27.3315 C83.685,28.8855 82.635,30.0195 81.291,30.0195 Z M106.9005,18.375 L102.207,18.375 L102.207,31.5 L104.1705,31.5 L104.1705,26.523 L106.911,26.523 C109.0845,26.523 111.216,24.948 111.216,22.449 C111.216,19.95 109.0635,18.375 106.9005,18.375 Z M106.9425,24.7065 L104.16,24.7065 L104.16,20.202 L106.9425,20.202 C108.4125,20.202 109.242,21.42 109.242,22.449 C109.242,23.4675 108.4125,24.7065 106.9425,24.7065 Z M119.0595,22.8165 C117.642,22.8165 116.172,23.4465 115.563,24.822 L117.306,25.5465 C117.6735,24.822 118.3665,24.5805 119.091,24.5805 C120.1095,24.5805 121.1385,25.1895 121.149,26.271 L121.149,26.4075 C120.792,26.208 120.036,25.9035 119.1015,25.9035 C117.222,25.9035 115.3215,26.9325 115.3215,28.854 C115.3215,30.6075 116.8545,31.7415 118.5765,31.7415 C119.889,31.7415 120.624,31.1535 121.0755,30.4605 L121.1385,30.4605 L121.1385,31.479 L123.028547,31.479 L123.028547,26.4495 C123.039,24.1185 121.296,22.8165 119.0595,22.8165 Z M118.818,30.009 C118.1775,30.009 117.285,29.6835 117.285,28.896 C117.285,27.888 118.398,27.4995 119.364,27.4995 C120.225,27.4995 120.6345,27.6885 121.149,27.9405 C121.002,29.148 119.952,30.009 118.818,30.009 Z M129.927,23.1105 L127.68,28.8015 L127.617,28.8015 L125.286,23.1105 L123.1755,23.1105 L126.672,31.0695 L124.677,35.49 L126.7245,35.49 L132.111,23.1105 L129.927,23.1105 L129.927,23.1105 Z M112.287,31.5 L114.2505,31.5 L114.2505,18.375 L112.287,18.375 L112.287,31.5 Z"
                          id="Shape"
                          fill="#FFFFFF"
                        />
                        <g id="Group" transform="translate(9.450000, 7.350000)">
                          <path
                            d="M1.512,0.567 C1.2075,0.8925 1.029,1.3965 1.029,2.037 L1.029,25.263 C1.029,25.914 1.2075,26.418 1.512,26.733 L1.5855,26.8065 L14.595,13.8075 L14.595,13.65 L14.595,13.4925 L1.5855,0.4935 L1.512,0.567 Z"
                            id="Path"
                            fill="url(#linearGradient-1)"
                          />
                          <path
                            d="M18.9315,18.144 L14.595,13.8075 L14.595,13.65 L14.595,13.4925 L18.9315,9.156 L19.026,9.2085 L24.1605,12.1275 C25.6305,12.957 25.6305,14.322 24.1605,15.162 L19.026,18.081 L18.9315,18.144 Z"
                            id="Path"
                            fill="url(#linearGradient-2)"
                          />
                          <path
                            d="M19.026,18.0915 L14.595,13.65 L1.512,26.7435 C1.995,27.258 2.793,27.321 3.696,26.8065 L19.026,18.0915"
                            id="Path"
                            fill="url(#linearGradient-3)"
                          />
                          <path
                            d="M19.026,9.219 L3.6855,0.504 C2.7825,-0.0105 1.9845,0.0525 1.5015,0.567 L14.595,13.65 L19.026,9.219 Z"
                            id="Path"
                            fill="url(#linearGradient-4)"
                          />
                          <g
                            transform="translate(0.000000, 17.850000)"
                            fill="#000000"
                            id="Path"
                          >
                            <path
                              d="M18.9315,0.147 L3.6855,8.8095 C2.835,9.2925 2.0685,9.261 1.5855,8.82 L1.5855,8.82 L1.512,8.8935 L1.512,8.8935 L1.5855,8.967 L1.5855,8.967 C2.079,9.408 2.835,9.4395 3.6855,8.9565 L19.026,0.2415 L18.9315,0.147 Z"
                              opacity="0.2"
                            />
                            <path
                              d="M1.512,8.736 C1.2075,8.4105 1.029,7.9065 1.029,7.266 L1.029,7.4235 C1.029,8.0745 1.2075,8.5785 1.512,8.8935 L1.5855,8.82 L1.512,8.736 Z"
                              opacity="0.12"
                            />
                          </g>
                          <path
                            d="M24.1605,15.015 L18.921,17.9865 L19.0155,18.081 L24.15,15.162 C24.885,14.742 25.2525,14.196 25.2525,13.65 L25.2525,13.65 C25.2,14.154 24.8325,14.637 24.1605,15.015 Z"
                            id="Path"
                            fill="#000000"
                            opacity="0.12"
                          />
                          <path
                            d="M3.6855,0.6615 L24.1605,12.2955 C24.822,12.6735 25.2,13.1565 25.263,13.6605 L25.263,13.6605 C25.263,13.1145 24.8955,12.558 24.1605,12.1485 L3.6855,0.504 C2.2155,-0.3255 1.0185,0.3675 1.0185,2.0475 L1.0185,2.205 C1.0185,0.5145 2.226,-0.1785 3.6855,0.6615 Z"
                            id="Path"
                            fill="#FFFFFF"
                            opacity="0.25"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
            <li className="apps-links__shopify">
              <a
                data-qaid="footer_shopify"
                href="https://apps.shopify.com/promo-com-promo-video-maker"
                target="_blank"
              >
                <svg
                  width="155px"
                  height="42px"
                  viewBox="0 0 155 42"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <title>1E1D15AB-8FAE-4E46-B523-4D2DC10BC8F8</title>
                  <desc>Created with sketchtool.</desc>
                  <g
                    id="Footer-Design-25.12"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Assets"
                      transform="translate(-153.000000, -218.000000)"
                      fillRule="nonzero"
                    >
                      <g
                        id="Shopify-App-Store-Badge-Final-Black"
                        transform="translate(153.000000, 218.000000)"
                      >
                        <g id="Group">
                          <path
                            d="M4.64986667,41.0666667 C2.34266667,41.0666667 0.466666667,39.2233333 0.466666667,36.9581333 L0.466666667,5.04186667 C0.466666667,2.77666667 2.34266667,0.933333333 4.64986667,0.933333333 L150.2844,0.933333333 C152.590667,0.933333333 154.4676,2.77666667 154.4676,5.04186667 L154.4676,36.9581333 C154.4676,39.2233333 152.5916,41.0666667 150.2844,41.0666667 L4.64986667,41.0666667 Z"
                            id="Path"
                            fill="#000000"
                          />
                          <path
                            d="M150.2844,41.4166667 L4.64893333,41.4166667 C2.14946667,41.4166667 0.116666667,39.4165333 0.116666667,36.9581333 L0.116666667,5.04186667 C0.116666667,2.58346667 2.1504,0.583333333 4.64893333,0.583333333 L150.283467,0.583333333 C152.782933,0.583333333 154.815734,2.58346667 154.815734,5.04186667 L154.815734,36.9581333 C154.815734,39.4165333 152.782933,41.4166667 150.2844,41.4166667 Z M4.64893333,1.28333333 C2.53586667,1.28333333 0.816666667,2.96986667 0.816666667,5.04186667 L0.816666667,36.9581333 C0.816666667,39.0301333 2.53586667,40.7166667 4.64893333,40.7166667 L150.283467,40.7166667 C152.397467,40.7166667 154.115733,39.0301333 154.115733,36.9581333 L154.115733,5.04186667 C154.115733,2.96986667 152.396533,1.28333333 150.283467,1.28333333 L4.64893333,1.28333333 Z"
                            id="Shape"
                            fill="#C3CCD4"
                          />
                        </g>
                        <g
                          id="Group"
                          transform="translate(8.400000, 8.400000)"
                          fill="#FFFFFF"
                        >
                          <g>
                            <path
                              d="M18.0329333,4.36146667 C17.9498667,4.35493333 16.184,4.22333333 16.184,4.22333333 C16.184,4.22333333 14.9576,3.00626667 14.8232,2.87093333 C14.7905333,2.83826667 14.7504,2.81586667 14.7065333,2.80186667 L13.832,23.0104 L20.7414667,21.5096 C20.7414667,21.5096 18.2494667,4.66293333 18.2336,4.54813333 C18.2177333,4.4324 18.116,4.36893333 18.0329333,4.36146667 Z"
                              id="Path"
                            />
                            <path
                              d="M14.3229333,2.8084 C14.308,2.81306667 14.0550667,2.89053333 13.6369333,3.02026667 C13.2272,1.84146667 12.5048,0.7588 11.2326667,0.7588 C11.1972,0.7588 11.1617333,0.760666667 11.1253333,0.762533333 C10.7632,0.284666667 10.3161333,0.0765333333 9.9288,0.0765333333 C6.9664,0.0765333333 5.55146667,3.78 5.1072,5.6616 C3.9564,6.01813333 3.1388,6.272 3.03426667,6.30466667 C2.39213333,6.50626667 2.3716,6.5268 2.2876,7.1316 C2.22413333,7.58986667 0.542266667,20.5912 0.542266667,20.5912 L13.5165333,23.0225333 L14.392,2.79253333 C14.3658667,2.7972 14.3416,2.8028 14.3229333,2.8084 Z M11.0282667,3.6988 C11.0282667,3.7436 11.0282667,3.7856 11.0273333,3.8276 C10.3058667,4.05066667 9.5228,4.29333333 8.73786667,4.536 C9.1784,2.83453333 10.0053333,2.0132 10.7277333,1.70333333 C10.9097333,2.15973333 11.0282667,2.81493333 11.0282667,3.6988 Z M9.8476,0.8708 C9.97546667,0.8708 10.1042667,0.913733333 10.2274667,0.998666667 C9.27826667,1.44573333 8.26,2.5704 7.83066667,4.81786667 C7.20253333,5.012 6.5884,5.2024 6.02093333,5.3788 C6.52493333,3.66426667 7.7196,0.8708 9.8476,0.8708 Z M10.3581333,10.8873333 C10.3581333,10.8873333 9.59093333,10.4776 8.65106667,10.4776 C7.27253333,10.4776 7.20346667,11.3428 7.20346667,11.5602667 C7.20346667,12.7493333 10.3030667,13.2048 10.3030667,15.9898667 C10.3030667,18.1813333 8.91333333,19.5925333 7.0392,19.5925333 C4.7908,19.5925333 3.64,18.1925333 3.64,18.1925333 L4.242,16.2036 C4.242,16.2036 5.42453333,17.2181333 6.42133333,17.2181333 C7.0728,17.2181333 7.33786667,16.7048 7.33786667,16.3305333 C7.33786667,14.7793333 4.79453333,14.7102667 4.79453333,12.1613333 C4.79453333,10.0165333 6.33453333,7.9408 9.44253333,7.9408 C10.64,7.9408 11.2317333,8.28426667 11.2317333,8.28426667 L10.3581333,10.8873333 Z M11.8048,3.5868 C11.8048,3.5084 11.8057333,3.43186667 11.8057333,3.34786667 C11.8057333,2.6152 11.704,2.02533333 11.5406667,1.55773333 C12.1958667,1.63986667 12.6326667,2.3856 12.9136,3.24333333 C12.5841333,3.346 12.2098667,3.46173333 11.8048,3.5868 Z"
                              id="Shape"
                            />
                          </g>
                          <g transform="translate(27.066667, 10.266667)">
                            <path
                              d="M3.98626667,11.6862667 C1.66226667,11.6862667 0.584266667,10.2302667 0.360266667,8.78826667 L1.85826667,8.56426667 C2.04026667,9.55826667 2.53026667,10.4542667 3.98626667,10.4542667 C5.07826667,10.4542667 5.86226667,9.82426667 5.86226667,8.88626667 C5.86226667,7.87826667 5.33026667,7.45826667 3.77626667,7.0392 C1.76026667,6.5492 0.696266667,5.8212 0.696266667,4.0992 C0.696266667,2.5452 1.97026667,1.4112 3.88826667,1.4112 C5.77826667,1.4112 6.94026667,2.4192 7.20626667,3.9032 L5.73626667,4.1412 C5.54026667,3.1752 4.86826667,2.6292 3.8892,2.6292 C2.7692,2.6292 2.1812,3.1752 2.1812,3.9872 C2.1812,4.8272 2.5452,5.2472 4.1972,5.6672 C6.2272,6.1712 7.3892,6.8712 7.3892,8.7472 C7.38826667,10.4552 6.03026667,11.6862667 3.98626667,11.6862667 Z"
                              id="Path"
                            />
                            <path
                              d="M8.81626667,0.8512 L10.3002667,0.8512 L10.3002667,5.3452 C10.6362667,4.6592 11.4062667,4.0852 12.5402667,4.0852 C13.9402667,4.0852 14.9062667,4.8972 14.9062667,6.8292 L14.9062667,11.5472 L13.3942667,11.5472 L13.3942667,6.9132 C13.3942667,5.8352 12.9462667,5.3452 11.9802667,5.3452 C11.0842667,5.3452 10.3002667,5.9192 10.3002667,7.0392 L10.3002667,11.5472 L8.81626667,11.5472 L8.81626667,0.8512 L8.81626667,0.8512 Z"
                              id="Path"
                            />
                            <path
                              d="M16.1382667,7.6132 C16.1382667,5.4712 17.6222667,4.0852 19.6102667,4.0852 C21.5982667,4.0852 23.0822667,5.4572 23.0822667,7.5852 L23.0822667,8.1592 C23.0822667,10.3152 21.5842667,11.6872 19.5962667,11.6872 C17.5942667,11.6872 16.1382667,10.2872 16.1382667,8.1872 L16.1382667,7.6132 Z M19.6102667,10.4972 C20.8142667,10.4972 21.5422667,9.6012 21.5422667,8.1872 L21.5422667,7.5992 C21.5422667,6.1572 20.8002667,5.2752 19.6102667,5.2752 C18.4062667,5.2752 17.6642667,6.1432 17.6642667,7.5852 L17.6642667,8.1732 C17.6642667,9.6152 18.3782667,10.4972 19.6102667,10.4972 Z"
                              id="Shape"
                            />
                            <path
                              d="M25.8533333,4.2252 L25.8533333,5.3872 C26.2593333,4.6872 27.1133333,4.0852 28.1493333,4.0852 C29.8713333,4.0852 31.1453333,5.3452 31.1453333,7.5292 L31.1453333,8.1592 C31.1453333,10.3572 29.9133333,11.6872 28.1213333,11.6872 C27.0293333,11.6872 26.2313333,11.1272 25.8533333,10.4272 L25.8533333,14.0532 L24.3693333,14.0532 L24.3693333,4.2252 L25.8533333,4.2252 Z M27.7862667,10.4822667 C28.9622667,10.4822667 29.6062667,9.68426667 29.6062667,8.20026667 L29.6062667,7.57026667 C29.6062667,6.03026667 28.8222667,5.27426667 27.7862667,5.27426667 C26.6522667,5.27426667 25.8262658,6.03026667 25.8262658,7.61226667 L25.8262658,8.15826667 C25.8253333,9.7412 26.5953333,10.4822667 27.7862667,10.4822667 Z"
                              id="Shape"
                            />
                            <path
                              d="M32.3073333,2.0972 C32.3073333,1.5932 32.7133333,1.2012 33.2173333,1.2012 C33.7353333,1.2012 34.1413333,1.5932 34.1413333,2.0972 C34.1413333,2.6012 33.7353333,2.9932 33.2173333,2.9932 C32.6993333,2.9932 32.3073333,2.6012 32.3073333,2.0972 Z M32.4753333,4.2252 L33.9733333,4.2252 L33.9733333,11.5472 L32.4753333,11.5472 L32.4753333,4.2252 Z"
                              id="Shape"
                            />
                            <path
                              d="M36.0033333,5.4152 L35.0513333,5.4152 L35.0513333,4.2252 L36.0033333,4.2252 L36.0033333,3.1752 C36.0033333,1.6352 36.8153333,0.7952 38.3693333,0.7952 C38.8453333,0.7952 39.2093333,0.8512 39.5033333,0.9632 L39.5033333,2.1532 C39.3073333,2.0552 38.9153333,1.9852 38.5513333,1.9852 C37.7813333,1.9852 37.5153333,2.4332 37.5153333,3.1192 L37.5153333,4.2252 L39.4193333,4.2252 L39.4193333,5.4152 L37.5153333,5.4152 L37.5153333,11.5472 L36.0033333,11.5472 L36.0033333,5.4152 Z"
                              id="Path"
                            />
                            <polygon
                              id="Path"
                              points="43.6053333 9.0692 45.3413333 4.2252 46.8253333 4.2252 43.0593333 14.0532 41.5613333 14.0532 42.8073333 10.8192 40.0913333 4.2252 41.7153333 4.2252"
                            />
                            <path
                              d="M55.8973333,8.9712 L52.3553333,8.9712 L51.5993333,11.5472 L50.1293333,11.5472 L53.1402667,1.5372 L55.2533333,1.5372 L58.2344,11.5472 L56.6384,11.5472 L55.8973333,8.9712 Z M52.6913333,7.7952 L55.5613333,7.7952 L54.1193333,2.8392 L52.6913333,7.7952 Z"
                              id="Shape"
                            />
                            <path
                              d="M60.8393333,4.2252 L60.8393333,5.3872 C61.2462667,4.6872 62.1002667,4.0852 63.1353333,4.0852 C64.8582667,4.0852 66.1313333,5.3452 66.1313333,7.5292 L66.1313333,8.1592 C66.1313333,10.3572 64.9002667,11.6872 63.1082667,11.6872 C62.0162667,11.6872 61.2182667,11.1272 60.8393333,10.4272 L60.8393333,14.0532 L59.3553333,14.0532 L59.3553333,4.2252 L60.8393333,4.2252 Z M62.7713333,10.4822667 C63.9473333,10.4822667 64.5913333,9.68426667 64.5913333,8.20026667 L64.5913333,7.57026667 C64.5913333,6.03026667 63.8073333,5.27426667 62.7713333,5.27426667 C61.6373333,5.27426667 60.8113333,6.03026667 60.8113333,7.61226667 L60.8113333,8.15826667 C60.8113333,9.7412 61.5804,10.4822667 62.7713333,10.4822667 Z"
                              id="Shape"
                            />
                            <path
                              d="M68.9173333,4.2252 L68.9173333,5.3872 C69.3233333,4.6872 70.1773333,4.0852 71.2133333,4.0852 C72.9353333,4.0852 74.2093333,5.3452 74.2093333,7.5292 L74.2093333,8.1592 C74.2093333,10.3572 72.9773333,11.6872 71.1853333,11.6872 C70.0933333,11.6872 69.2962667,11.1272 68.9173333,10.4272 L68.9173333,14.0532 L67.4333333,14.0532 L67.4333333,4.2252 L68.9173333,4.2252 Z M70.8493333,10.4822667 C72.0253333,10.4822667 72.6684,9.68426667 72.6684,8.20026667 L72.6684,7.57026667 C72.6684,6.03026667 71.8844,5.27426667 70.8493333,5.27426667 C69.7144,5.27426667 68.8884,6.03026667 68.8884,7.61226667 L68.8884,8.15826667 C68.8893333,9.7412 69.6593333,10.4822667 70.8493333,10.4822667 Z"
                              id="Shape"
                            />
                            <path
                              d="M81.5724,11.6862667 C79.2484,11.6862667 78.1704,10.2302667 77.9464,8.78826667 L79.4434667,8.56426667 C79.6254667,9.55826667 80.1164,10.4542667 81.5714667,10.4542667 C82.6634667,10.4542667 83.4474667,9.82426667 83.4474667,8.88626667 C83.4474667,7.87826667 82.9164,7.45826667 81.3624,7.0392 C79.3464,6.5492 78.2824,5.8212 78.2824,4.0992 C78.2824,2.5452 79.5554667,1.4112 81.4744,1.4112 C83.3634667,1.4112 84.5264,2.4192 84.7924,3.9032 L83.3224,4.1412 C83.1264,3.1752 82.4544,2.6292 81.4753333,2.6292 C80.3553333,2.6292 79.7673333,3.1752 79.7673333,3.9872 C79.7673333,4.8272 80.1313333,5.2472 81.7824,5.6672 C83.8133333,6.1712 84.9744,6.8712 84.9744,8.7472 C84.9744,10.4552 83.6173333,11.6862667 81.5724,11.6862667 Z"
                              id="Path"
                            />
                            <path
                              d="M88.1944,2.2232 L88.1944,4.2252 L90.0284,4.2252 L90.0284,5.4152 L88.1944,5.4152 L88.1944,9.4752 C88.1944,10.1472 88.5304,10.4132 89.1473333,10.4132 C89.5113333,10.4132 89.8613333,10.3572 90.1133333,10.2452 L90.1133333,11.4352 C89.8324,11.5612 89.4404,11.6452 88.8944,11.6452 C87.3973333,11.6452 86.6973333,10.9032 86.6973333,9.6152 L86.6973333,5.4152 L85.7313333,5.4152 L85.7313333,4.2252 L86.6973333,4.2252 L86.6973333,2.2232 L88.1944,2.2232 L88.1944,2.2232 Z"
                              id="Path"
                            />
                            <path
                              d="M90.9533333,7.6132 C90.9533333,5.4712 92.4373333,4.0852 94.4253333,4.0852 C96.4133333,4.0852 97.8973333,5.4572 97.8973333,7.5852 L97.8973333,8.1592 C97.8973333,10.3152 96.3993333,11.6872 94.4113333,11.6872 C92.4093333,11.6872 90.9542667,10.2872 90.9542667,8.1872 L90.9542667,7.6132 L90.9533333,7.6132 Z M94.4253333,10.4972 C95.6293333,10.4972 96.3564,9.6012 96.3564,8.1872 L96.3564,7.5992 C96.3564,6.1572 95.6144,5.2752 94.4253333,5.2752 C93.2213333,5.2752 92.4793333,6.1432 92.4793333,7.5852 L92.4793333,8.1732 C92.4793333,9.6152 93.1933333,10.4972 94.4253333,10.4972 Z"
                              id="Shape"
                            />
                            <path
                              d="M99.1853333,4.2252 L100.669333,4.2252 L100.669333,5.5272 C101.1164,4.6312 101.747333,4.1132 103.189333,4.1272 L103.189333,5.5412 C101.5364,5.5552 100.669333,6.0032 100.669333,7.5292 L100.669333,11.5472 L99.1853333,11.5472 L99.1853333,4.2252 Z"
                              id="Path"
                            />
                            <path
                              d="M107.1504,11.6862667 C105.1484,11.6862667 103.735333,10.3702667 103.735333,8.18626667 L103.735333,7.61226667 C103.735333,5.47026667 105.135333,4.08426667 107.0804,4.08426667 C108.7884,4.08426667 110.287333,5.09226667 110.287333,7.54226667 L110.287333,8.20026667 L105.247333,8.20026667 C105.262267,9.78226667 105.975333,10.5242667 107.193333,10.5242667 C108.258267,10.5242667 108.775333,9.86626667 108.929333,9.32026667 L110.231333,9.62826667 C109.963467,10.6232 108.9704,11.6862667 107.1504,11.6862667 Z M105.2604,7.1652 L108.8024,7.1652 L108.8024,7.1232 C108.745467,5.7792 108.1024,5.2192 107.079467,5.2192 C106.1704,5.2192 105.4004,5.7932 105.2604,7.1652 Z"
                              id="Shape"
                            />
                          </g>
                          <g transform="translate(28.000000, 2.800000)">
                            <polygon
                              id="Path"
                              points="0.829733333 0.14 3.52333333 0.14 3.52333333 0.819466667 1.68746667 0.819466667 1.68746667 2.1532 3.15466667 2.1532 3.15466667 2.8196 1.68746667 2.8196 1.68746667 4.68066667 0.829733333 4.68066667 0.829733333 0.14"
                            />
                            <polygon
                              id="Path"
                              points="4.69466667 0.14 5.55893333 0.14 5.55893333 4.6816 4.69466667 4.6816"
                            />
                            <polygon
                              id="Path"
                              points="6.9916 0.14 7.99493333 0.14 9.65906667 3.29 9.65906667 0.14 10.4402667 0.14 10.4402667 4.6816 9.56386667 4.6816 7.76626667 1.28333333 7.76626667 4.6816 6.99066667 4.6816 6.99066667 0.14"
                            />
                            <path
                              d="M13.2888,0.14 C14.7308,0.14 15.4550667,0.908133333 15.4550667,2.15973333 L15.4550667,2.6292 C15.4550667,3.86773333 14.7438667,4.68066667 13.2888,4.68066667 L11.8402667,4.68066667 L11.8402667,0.14 L13.2888,0.14 Z M12.698,0.812933333 L12.698,4.00213333 L13.2570667,4.00213333 C14.1521333,4.00213333 14.5656,3.51866667 14.5656,2.63013333 L14.5656,2.1728 C14.5656,1.302 14.1848,0.812933333 13.2505333,0.812933333 L12.698,0.812933333 L12.698,0.812933333 Z"
                              id="Shape"
                            />
                            <polygon
                              id="Path"
                              points="18.5304 0.14 19.3937333 0.14 19.3937333 4.6816 18.5304 4.6816"
                            />
                            <polygon
                              id="Path"
                              points="21.7037333 0.819466667 20.5156 0.819466667 20.5156 0.14 23.7486667 0.14 23.7486667 0.819466667 22.568 0.819466667 22.568 4.6816 21.7046667 4.6816 21.7046667 0.819466667"
                            />
                            <path
                              d="M26.488,2.65533333 L26.488,2.1532 C26.488,0.914666667 27.314,0.0821333333 28.5012,0.0821333333 C29.6949333,0.0821333333 30.5022667,0.888533333 30.5022667,2.14666667 L30.5022667,2.63573333 C30.5022667,3.88733333 29.7210667,4.74413333 28.4956,4.74413333 C27.2701333,4.74413333 26.488,3.88733333 26.488,2.65533333 Z M29.6137333,2.6488 L29.6137333,2.1532 C29.6137333,1.32066667 29.2198667,0.762533333 28.5021333,0.762533333 C27.7844,0.762533333 27.384,1.3216 27.384,2.1532 L27.384,2.6488 C27.384,3.51866667 27.7909333,4.05253333 28.5021333,4.05253333 C29.2133333,4.05253333 29.6137333,3.51213333 29.6137333,2.6488 Z"
                              id="Shape"
                            />
                            <polygon
                              id="Path"
                              points="31.7370667 0.14 32.7404 0.14 34.4045333 3.29 34.4045333 0.14 35.1857333 0.14 35.1857333 4.6816 34.3093333 4.6816 32.5117333 1.28333333 32.5117333 4.6816 31.7361333 4.6816 31.7361333 0.14"
                            />
                            <polygon
                              id="Path"
                              points="39.2774667 0.819466667 38.0893333 0.819466667 38.0893333 0.14 41.3224 0.14 41.3224 0.819466667 40.1408 0.819466667 40.1408 4.6816 39.2774667 4.6816"
                            />
                            <polygon
                              id="Path"
                              points="42.4246667 0.14 43.2824 0.14 43.2824 2.04586667 45.0361333 2.04586667 45.0361333 0.14 45.8929333 0.14 45.8929333 4.6816 45.0361333 4.6816 45.0361333 2.744 43.2824 2.744 43.2824 4.6816 42.4246667 4.6816"
                            />
                            <polygon
                              id="Path"
                              points="47.2994667 0.14 50.0117333 0.14 50.0117333 0.819466667 48.1572 0.819466667 48.1572 2.02626667 49.6552 2.02626667 49.6552 2.6684 48.1572 2.6684 48.1572 4.00213333 50.1134667 4.00213333 50.1134667 4.6816 47.2994667 4.6816 47.2994667 0.14"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__follow">
          <div className="follow-title footer-title"> follow us</div>
          <ul className="follow-links">
            <li>
              <a
                data-qaid="footer_follow_fb"
                className="external-link"
                data-linkname="facebook"
                data-where="footer"
                href="https://www.facebook.com/promodotcom"
                target="_blank"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <title>B04D9E13-60FE-4309-B201-2BEF121F5502</title>
                  <desc>Created with sketchtool.</desc>
                  <g
                    id="Footer-Design-25.12"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Assets"
                      transform="translate(-153.000000, -308.000000)"
                      fill="#000000"
                    >
                      <g
                        id="icn_facebook"
                        transform="translate(153.000000, 308.000000)"
                      >
                        <path
                          d="M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M17.833,9 C16.8035,9 15.9785,9.305 15.36,9.915 C14.7415,10.525 14.4315,11.384 14.4315,12.491 L14.4315,12.491 L14.4315,14.4375 L12.1545,14.4375 L12.1545,17.0805 L14.4315,17.0805 L14.4315,23.8575 L17.1635,23.8575 L17.1635,17.0805 L19.4315,17.0805 L19.7795,14.4375 L17.1635,14.4375 L17.1635,12.75 C17.1635,12.321 17.253,12 17.4315,11.7855 C17.61,11.571 17.9555,11.464 18.467,11.464 L18.467,11.464 L19.869,11.464 L19.869,9.107 C19.3865,9.0355 18.708,9 17.833,9 Z"
                          id="Combined-Shape"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_follow_ig"
                className="external-link"
                data-linkname="instagram"
                data-where="footer"
                href="https://www.instagram.com/promodotcom"
                target="_blank"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <title>C60ABDCE-6701-4731-87C3-3A23E6C5E53D</title>
                  <desc>Created with sketchtool.</desc>
                  <g
                    id="Footer-Design-25.12"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Assets"
                      transform="translate(-201.000000, -308.000000)"
                      fill="#000000"
                    >
                      <g
                        id="icn_instagram"
                        transform="translate(201.000000, 308.000000)"
                      >
                        <path
                          d="M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16.3307608,9.2757574 L15.7312228,9.27576559 C14.5611627,9.27788757 13.7397308,9.29269231 13.2685,9.319 C12.06,9.377 11.125,9.737 10.4625,10.3995 C9.8,11.062 9.44,11.9975 9.382,13.2055 C9.353,13.717 9.3385,14.6375 9.3385,15.968 L9.3387492,16.2677772 C9.34074556,17.4378373 9.35476923,18.2592692 9.382,18.7305 C9.44,19.9395 9.8,20.8745 10.4625,21.537 C11.125,22.1995 12.0605,22.5595 13.2685,22.6175 C13.78,22.6465 14.7005,22.661 16.031,22.661 L16.3307608,22.6607344 C17.5006953,22.6586124 18.3213462,22.6438077 18.7935,22.6175 C20.0025,22.5595 20.9375,22.1995 21.6,21.537 C22.2625,20.8745 22.6225,19.9385 22.6805,18.7305 C22.7095,18.219 22.724,17.2985 22.724,15.968 C22.724,14.6375 22.71,13.717 22.6805,13.2055 C22.6225,11.997 22.2625,11.062 21.6,10.3995 C20.9375,9.737 20.0015,9.377 18.7935,9.319 C18.282,9.29 17.3615,9.2755 16.031,9.2755 Z M16.698,10.474 C17.1025,10.4705 17.4085,10.4705 17.6175,10.474 C17.8265,10.477 18.1065,10.4855 18.4585,10.5 C18.8095,10.515 19.109,10.544 19.356,10.5875 C19.603,10.631 19.8105,10.6845 19.979,10.749 C20.269,10.865 20.5255,11.034 20.746,11.2545 C20.9665,11.475 21.1355,11.7315 21.2515,12.0215 C21.3155,12.19 21.3695,12.398 21.413,12.6445 C21.457,12.891 21.486,13.1905 21.5005,13.542 C21.515,13.8935 21.524,14.174 21.5265,14.383 C21.529,14.5925 21.529,14.899 21.5265,15.3025 C21.5249375,15.5553125 21.5235703,15.7370312 21.5227646,15.8475342 L21.5227646,16.0921689 C21.5235703,16.2028281 21.5249375,16.3843125 21.5265,16.6365 C21.529,17.041 21.5295,17.347 21.5265,17.556 C21.5235,17.765 21.515,18.045 21.5005,18.397 C21.4855,18.748 21.4565,19.048 21.413,19.2945 C21.3695,19.5415 21.316,19.749 21.2515,19.9175 C21.1355,20.2085 20.9665,20.464 20.746,20.6845 C20.5255,20.905 20.269,21.074 19.979,21.19 C19.8105,21.254 19.6025,21.308 19.356,21.3515 C19.1095,21.3955 18.81,21.4245 18.4585,21.439 C18.107,21.4535 17.8265,21.4625 17.6175,21.465 C17.408,21.4675 17.1015,21.4675 16.698,21.465 C16.394625,21.463125 16.193625,21.4615312 16.0952109,21.4608516 L15.9662266,21.4608516 C15.8674375,21.4615312 15.666625,21.463125 15.364,21.465 C14.9595,21.4675 14.6535,21.468 14.4445,21.465 C14.2355,21.462 13.9555,21.4535 13.6035,21.439 C13.2525,21.424 12.9525,21.395 12.706,21.3515 C12.459,21.308 12.252,21.2545 12.083,21.19 C11.792,21.074 11.5365,20.905 11.316,20.6845 C11.0955,20.464 10.9265,20.2075 10.8105,19.9175 C10.7465,19.749 10.693,19.542 10.649,19.2945 C10.6055,19.048 10.576,18.7485 10.5615,18.397 C10.547,18.0455 10.538,17.765 10.5355,17.556 C10.533,17.3465 10.533,17.04 10.5355,16.6365 C10.538,16.232 10.54,16.0105 10.54,15.9695 C10.54,15.9285 10.538,15.706 10.5355,15.3025 C10.533,14.899 10.5325,14.592 10.5355,14.383 C10.5385,14.174 10.547,13.894 10.5615,13.542 C10.5765,13.191 10.6055,12.8915 10.649,12.6445 C10.6925,12.3975 10.746,12.1905 10.8105,12.0215 C10.9265,11.7315 11.0955,11.475 11.316,11.2545 C11.5365,11.034 11.793,10.865 12.083,10.749 C12.2515,10.685 12.4585,10.6315 12.706,10.5875 C12.9525,10.544 13.252,10.5145 13.6035,10.5 C13.955,10.4855 14.2355,10.4765 14.4445,10.474 C14.654,10.4715 14.9605,10.4715 15.364,10.474 C15.667375,10.475875 15.8678125,10.4774687 15.9663672,10.4781484 L16.0957734,10.4781484 C16.1945625,10.4774687 16.395375,10.475875 16.698,10.474 Z M16.0315,12.534 C15.0785,12.534 14.268,12.868 13.6,13.536 C12.932,14.204 12.598,15.0145 12.598,15.9675 C12.598,16.9205 12.9315,17.731 13.6005,18.399 C14.2685,19.067 15.079,19.401 16.032,19.401 C16.985,19.401 17.7955,19.067 18.4635,18.399 C19.1315,17.731 19.4655,16.92 19.4655,15.9675 C19.4655,15.015 19.1315,14.2045 18.4635,13.5365 L18.4635,13.5365 C17.795,12.868 16.985,12.534 16.0315,12.534 Z M16.0315,13.737 C16.6475,13.737 17.1735,13.955 17.609,14.3905 C18.0445,14.826 18.2625,15.352 18.2625,15.968 C18.2625,16.584 18.0445,17.11 17.609,17.5455 C17.1735,17.981 16.6475,18.199 16.0315,18.199 C15.4155,18.199 14.8895,17.981 14.454,17.5455 C14.0185,17.11 13.8005,16.584 13.8005,15.968 C13.8005,15.352 14.0185,14.826 14.454,14.3905 C14.8895,13.955 15.4155,13.737 16.0315,13.737 Z M19.6055,11.593 C19.385,11.593 19.1965,11.6715 19.0395,11.8285 C18.8825,11.9845 18.804,12.174 18.804,12.3945 C18.804,12.615 18.8825,12.8035 19.0395,12.9605 C19.1955,13.1175 19.385,13.196 19.6055,13.196 C19.826,13.196 20.0145,13.1175 20.1715,12.9605 C20.3285,12.8045 20.407,12.615 20.407,12.3945 C20.407,12.174 20.3285,11.9855 20.1715,11.8285 C20.0145,11.6725 19.826,11.594 19.6055,11.593 Z"
                          id="Combined-Shape"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_follow_yt"
                className="external-link"
                data-linkname="youtube"
                data-where="footer"
                href="https://www.youtube.com/channel/UC0d_7BlGBgDcf62o766FkPQ/featured"
                target="_blank"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <title>FDF4F3C4-4B10-4E28-9475-038AD4D7C12D</title>
                  <desc>Created with sketchtool.</desc>
                  <g
                    id="Footer-Design-25.12"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Assets"
                      transform="translate(-249.000000, -308.000000)"
                      fill="#000000"
                    >
                      <g
                        id="icn_youtube"
                        transform="translate(249.000000, 308.000000)"
                      >
                        <path
                          d="M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16.2275463,11.0006944 L15.7724537,11.0006944 C15.0444444,11.0041667 12.725,11.025 11.1,11.15 C10.8,11.2 10.25,11.2 9.7,11.75 C9.3,12.2 9.15,13.15 9.15,13.15 C9.15,13.15 9,14.3 9,15.45 L9,16.55 C9,17.7 9.15,18.85 9.15,18.85 C9.15,18.85 9.3,19.85 9.7,20.25 C10.25,20.8 10.95,20.8 11.25,20.85 C12.35,20.95 16,21 16,21 C16,21 18.95,21 20.9,20.85 C21.15,20.8 21.75,20.8 22.3,20.25 C22.7,19.8 22.85,18.85 22.85,18.85 C22.85,18.85 23,17.7 23,16.55 L23,15.45 C23,14.3 22.85,13.15 22.85,13.15 C22.85,13.15 22.7,12.15 22.3,11.75 C21.75,11.2 21.15,11.2 20.9,11.15 C19.275,11.025 16.9555556,11.0041667 16.2275463,11.0006944 Z M14.55,13.85 L18.35,15.85 L14.55,17.85 L14.55,13.85 Z"
                          id="Combined-Shape"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_follow_tw"
                className="external-link"
                data-linkname="twitter"
                data-where="footer"
                href="https://twitter.com/Promodotcom"
                target="_blank"
              >
                <svg
                  width={32}
                  height={32}
                  viewBox="0 0 41 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.4727 40.0448C31.5184 40.0448 40.4727 31.0905 40.4727 20.0448C40.4727 8.99907 31.5184 0.0447693 20.4727 0.0447693C9.42696 0.0447693 0.472656 8.99907 0.472656 20.0448C0.472656 31.0905 9.42696 40.0448 20.4727 40.0448ZM30.3618 9.04362L22.5507 18.3675H22.5503L31.0456 31.0634H24.7977L19.077 22.514L11.9147 31.0634H10.0636L18.2552 21.2859L10.0636 9.04362H16.3115L21.7285 17.1394L28.5108 9.04362H30.3618ZM19.1855 20.1747L20.0155 21.3937V21.3942L25.6685 29.6975H28.5117L21.5841 19.5219L20.7541 18.3029L15.4248 10.4746H12.5816L19.1855 20.1747Z"
                    fill="black"
                  />
                </svg>
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_follow_li"
                className="external-link"
                data-linkname="linkedin"
                data-where="footer"
                href="https://www.linkedin.com/company/promodotcom"
                target="_blank"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <title>726B79B1-8C2A-4F70-A268-1986C25FB5D3</title>
                  <desc>Created with sketchtool.</desc>
                  <g
                    id="Footer-Design-25.12"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Assets"
                      transform="translate(-345.000000, -308.000000)"
                      fill="#000000"
                    >
                      <path
                        d="M361,308 C369.836556,308 377,315.163444 377,324 C377,332.836556 369.836556,340 361,340 C352.163444,340 345,332.836556 345,324 C345,315.163444 352.163444,308 361,308 Z M357.259,321.5805 L354.3125,321.5805 L354.3125,330.4285 L357.259,330.4285 L357.259,321.5805 Z M364.4735,321.3735 C364.0985,321.3735 363.757667,321.419667 363.451,321.512 C363.144333,321.604333 362.885333,321.733833 362.674,321.9005 C362.462667,322.067167 362.2945,322.222 362.1695,322.365 C362.0445,322.508 361.9225,322.674667 361.8035,322.865 L361.821,322.837 L361.8215,321.5795 L358.884,321.5795 L358.893,322.008 C358.899,322.293667 358.902,323.174667 358.902,324.651 C358.902,326.127333 358.896,328.053 358.884,330.428 L358.884,330.428 L361.8215,330.428 L361.8215,325.4905 C361.8215,325.187167 361.854167,324.946167 361.9195,324.7675 C362.0445,324.463833 362.2335,324.209333 362.4865,324.004 C362.7395,323.798667 363.0535,323.696 363.4285,323.696 C363.9405,323.696 364.317,323.873167 364.558,324.2275 C364.799,324.581833 364.9195,325.0715 364.9195,325.6965 L364.9195,325.6965 L364.9195,330.4285 L367.857,330.4285 L367.8575,325.356 C367.8575,324.052333 367.548,323.062667 366.929,322.387 C366.31,321.711333 365.4915,321.3735 364.4735,321.3735 Z M355.8035,317.320999 C355.3095,317.320667 354.909167,317.465 354.6025,317.754 C354.295833,318.043 354.1425,318.407667 354.1425,318.848 C354.1425,319.282667 354.291333,319.645833 354.589,319.9375 C354.886667,320.229167 355.2795,320.375 355.7675,320.375 L355.7675,320.375 L355.7855,320.375 C356.2855,320.375 356.688833,320.229167 356.9955,319.9375 C357.302167,319.645833 357.4525,319.282667 357.4465,318.848 C357.4405,318.407 357.288667,318.042333 356.991,317.754 C356.693333,317.465667 356.2975,317.321333 355.8035,317.320999 Z"
                        id="Combined-Shape"
                      />
                    </g>
                  </g>
                </svg>
              </a>
            </li>
            <li>
              <a
                data-qaid="footer_follow_pin"
                className="external-link"
                data-linkname="pinterest"
                data-where="footer"
                href="https://www.pinterest.com/meetpromo"
                target="_blank"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <title>10969483-CE1F-4CC8-A6B7-01DE9DED223F</title>
                  <desc>Created with sketchtool.</desc>
                  <g
                    id="Footer-Design-25.12"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Assets"
                      transform="translate(-393.000000, -308.000000)"
                      fill="#000000"
                    >
                      <path
                        d="M409,308 C417.836556,308 425,315.163444 425,324 C425,332.836556 417.836556,340 409,340 C400.163444,340 393,332.836556 393,324 C393,315.163444 400.163444,308 409,308 Z M409.375115,316 C408.731461,315.999642 408.100232,316.082919 407.481428,316.249833 C406.862624,316.416746 406.284421,316.666758 405.746817,316.999866 C405.209214,317.332975 404.734261,317.727107 404.321958,318.18226 C403.909656,318.637413 403.586254,319.170997 403.351752,319.783013 C403.117251,320.395029 403,321.047248 403,321.73967 L403,321.73967 C403.00105,322.074214 403.03535,322.415579 403.103951,322.764841 C403.172551,323.114103 403.274052,323.460314 403.408453,323.803473 C403.542853,324.146633 403.73343,324.44959 403.980181,324.712344 C404.226933,324.975098 404.509734,325.154575 404.828586,325.250774 C404.922387,325.270158 404.975587,325.27985 404.988187,325.27985 C405.125738,325.27985 405.241414,325.13555 405.335215,324.846952 C405.429015,324.558353 405.475915,324.324315 405.475915,324.144838 C405.475915,324.087047 405.43689,323.989232 405.35884,323.851394 C405.280789,323.713556 405.196439,323.567641 405.105788,323.41365 C405.015138,323.259659 404.930787,323.051286 404.852737,322.788532 C404.774686,322.525778 404.735661,322.253332 404.735661,321.971195 C404.735661,320.695832 405.154438,319.643021 405.991994,318.812762 C406.829549,317.982502 407.873255,317.567372 409.123113,317.567372 C410.22317,317.567013 411.115326,317.876252 411.79958,318.495088 C412.483834,319.113924 412.825961,319.977746 412.825961,321.086553 C412.825611,321.388075 412.805311,321.707005 412.765061,322.043344 C412.724811,322.379684 412.662335,322.735407 412.577635,323.110513 C412.492934,323.48562 412.374109,323.839728 412.221158,324.172837 C412.068207,324.505946 411.893206,324.810338 411.696154,325.086015 C411.499103,325.361691 411.253752,325.579576 410.9601,325.739669 C410.666448,325.899763 410.347771,325.979809 410.004069,325.979809 C409.604366,325.979809 409.263814,325.846817 408.982412,325.580832 C408.701011,325.314848 408.56031,324.979944 408.56031,324.576121 C408.56031,324.178759 408.697861,323.579486 408.972962,322.778302 C409.248064,321.977117 409.385615,321.364922 409.385615,320.941716 C409.385615,320.544354 409.279389,320.215911 409.066938,319.956388 C408.854487,319.696865 408.557685,319.567103 408.176532,319.567103 C407.676729,319.567103 407.264252,319.801141 406.9391,320.269216 C406.613948,320.737292 406.451372,321.237314 406.451372,321.769283 C406.451372,322.43586 406.551297,322.977521 406.751148,323.394266 C406.707398,323.586665 406.544822,324.237269 406.26342,325.346077 C405.982019,326.454884 405.774117,327.376318 405.639716,328.110379 C405.505316,328.844439 405.438115,329.506349 405.438115,330.09611 C405.438115,330.294611 405.485016,330.897115 405.578816,331.903621 L405.578816,331.903621 L405.663342,332 L405.794592,331.95208 C406.025594,331.631175 406.21932,331.353883 406.375771,331.120205 C406.532222,330.886526 406.675898,330.63813 406.806799,330.375017 C406.9377,330.111904 407.037625,329.911608 407.106576,329.774129 C407.175526,329.636649 407.256727,329.409073 407.350177,329.091399 C407.443628,328.773725 407.507678,328.546148 407.542328,328.408669 C407.576979,328.27119 407.650479,327.966797 407.76283,327.495491 C407.87518,327.024185 407.962681,326.663616 408.025331,326.413784 C408.206283,326.772738 408.506234,327.054696 408.925187,327.259658 C409.34414,327.464621 409.766067,327.567102 410.19097,327.567102 C410.834974,327.566743 411.425603,327.443263 411.962856,327.196662 C412.500109,326.950061 412.953187,326.620003 413.32209,326.206489 C413.690992,325.792974 414.003544,325.313771 414.259745,324.768879 C414.515947,324.223988 414.703373,323.656661 414.822024,323.066901 C414.940675,322.47714 415,321.874636 415,321.25939 C414.99965,320.2335 414.733998,319.313682 414.203045,318.499934 C413.672092,317.686186 412.981537,317.066093 412.131382,316.639657 C411.281227,316.21322 410.362471,316 409.375115,316 Z"
                        id="Combined-Shape"
                      />
                    </g>
                  </g>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer__terms">
        <ul className="terms-links">
          <li>
            <a data-qaid="footer_tos" href="https://promo.com/terms-of-service">
              Terms of Service
            </a>
          </li>
          <li>
            <a
              data-qaid="footer_privacy_policy"
              href="https://promo.com/privacy-policy"
            >
              Privacy Policy
            </a>
          </li>
          <li>
            <a
              data-qaid="footer_cookies_policy"
              href="https://promo.com/cookies-policy"
            >
              Cookies Policy
            </a>
          </li>
        </ul>
      </div>
    </footer>
    <div id="react-root">
      <div id="ratio-editor-root">
        <div />
      </div>
      <div id="pricing-popup-root" className="pricing-v3" />
      <div id="overcharge-root" />
      <div id="published-root" />
      <div id="download-confirmation-root" />
      <div id="loader-root" />
      <div id="popup-manager-container" />
      <div id="what-is-promo-root" />
    </div>
    <div id="fb-root" />
    <input
      type="hidden"
      name="stripe-pk"
      defaultValue="pk_live_51Ao6dQHGk0xxELMv8QBMg3qnWUSC9W6J5GJB4qTLsDf5euzFoVatmqZryoe8MzioCdPqaGvstoeAV9mU8jhZhftd005MrO5fzF"
    />
    <noscript>
      &lt;img height="1" width="1" style="display:none;" alt=""
      src="https://px.ads.linkedin.com/collect/?pid=650500&amp;fmt=gif"/&gt;
    </noscript>
    <div id="loom-companion-mv3" ext-id="liecbddmkiiihnedobmlmillhodjkdmb">
      <section id="shadow-host-companion" />
    </div>
    
   
    <div id="userpilotContent" key="" theme_id={0} />
    <div className="ReactModalPortal" />
    <div id="modal-portal">
      <div className="embed-pricing-page embed-pricing-page--hidden">
       
      </div>
    </div>
    
  
    <img
      src="https://t.co/i/adsct?bci=3&eci=2&event_id=0ec9bf72-2fc5-4167-b3b6-4c6a891fe98a&events=%5B%5B%22pageview%22%2C%7B%7D%5D%5D&integration=advertiser&p_id=Twitter&p_user_id=0&pl_id=975a4448-6a49-4a55-afe4-96b38f09b61f&tw_document_href=https%3A%2F%2Fpromo.com%2Fshare%2F65e905b9f40e455e11747bc2%3Futm_source%3Dold_share_page_share_dialog&tw_iframe_status=0&tw_order_quantity=0&tw_sale_amount=0&txn_id=o50rq&type=javascript&version=2.3.29"
      height={1}
      width={1}
      style={{ display: "none" }}
    />
    <img
      src="https://analytics.twitter.com/i/adsct?bci=3&eci=2&event_id=0ec9bf72-2fc5-4167-b3b6-4c6a891fe98a&events=%5B%5B%22pageview%22%2C%7B%7D%5D%5D&integration=advertiser&p_id=Twitter&p_user_id=0&pl_id=975a4448-6a49-4a55-afe4-96b38f09b61f&tw_document_href=https%3A%2F%2Fpromo.com%2Fshare%2F65e905b9f40e455e11747bc2%3Futm_source%3Dold_share_page_share_dialog&tw_iframe_status=0&tw_order_quantity=0&tw_sale_amount=0&txn_id=o50rq&type=javascript&version=2.3.29"
      height={1}
      width={1}
      style={{ display: "none" }}
    />
    <div
      id="batBeacon34230181159"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    >
      <img
        id="batBeacon889961109526"
        width={0}
        height={0}
        alt=""
        src="https://bat.bing.com/action/0?ti=5708154&Ver=2&mid=fcb7438f-dc0e-4a7f-addc-f130420f6220&sid=6cf91f00dc1511eeb6d07d58a270b58c&vid=1c2854a0d82e11ee8009c9436e4fdb74&vids=0&msclkid=N&pi=918639831&lg=en-US&sw=1512&sh=982&sc=30&tl=Promo.com%20%7C%20Marketing%20Video%20Maker%20%7C%20Promote%20Anything%20with%20Videos&p=https%3A%2F%2Fpromo.com%2Fshare%2F65e905b9f40e455e11747bc2%3Futm_source%3Dold_share_page_share_dialog&r=&lt=1065&evt=pageLoad&sv=1&rn=627062"
        style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
      />
    </div>
  
    <div className="intercom-lightweight-app">
      <div
        className="intercom-lightweight-app-launcher intercom-launcher"
        role="button"
        tabIndex={0}
        aria-label="Open Intercom Messenger"
        aria-live="polite"
      >
        <div className="intercom-lightweight-app-launcher-icon intercom-lightweight-app-launcher-icon-open">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 32">
            <path d="M28 32s-4.714-1.855-8.527-3.34H3.437C1.54 28.66 0 27.026 0 25.013V3.644C0 1.633 1.54 0 3.437 0h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H28V32zm-4.139-11.982a.88.88 0 00-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 00-1.29.107 1.01 1.01 0 00-.219.708.992.992 0 00.318.664c.142.128 3.537 3.15 9.762 3.15 6.226 0 9.621-3.022 9.763-3.15a.992.992 0 00.317-.664 1.01 1.01 0 00-.218-.707z" />
          </svg>
        </div>
        <div className="intercom-lightweight-app-launcher-icon intercom-lightweight-app-launcher-icon-minimize">
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  </>
  
  );
}
